import { ChangeDetectorRef, Component, OnInit, ElementRef, Renderer2, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { DatePipe } from '@angular/common';
import * as moment from "moment";
import { PhoneFormatPipe } from "../../pipes/phone-format.pipe";
import { LoaderService } from 'src/app/loader.service';
import { CommonPatternsService } from 'src/app/common-patterns.service';

import Chart from 'chart.js/auto';


import {
  AbstractControl,
  FormGroup,
  FormControl,
  Validators,
  FormBuilder,
} from '@angular/forms';
import Swal from 'sweetalert2';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { ClipboardService } from 'ngx-clipboard'
import { ToastrService } from "ngx-toastr";
import { postServiceWorkerMessage } from 'src/serviceworker/message';
import { WorkerMessageType } from 'src/serviceworker/service/events/message';
import { WorkerUrlPrefetchResult } from 'src/serviceworker/service/prefetch';
import { Observable, startWith, Subject, takeUntil } from 'rxjs';
import { Store } from '@ngrx/store';
import { selectAdvisorData, selectAdvisorError, selectAdvisorLoading } from 'src/app/state/selectors/advisors.selector';
import { loadAdvisorData, loadAdvisorDataSuccess } from 'src/app/state/actions/advisors.actions';
import { loadLanguageData } from 'src/app/state/actions';
import { selectLanguageData } from 'src/app/state/selectors';
import { loadBrokerConfigData } from 'src/app/state/actions/brokerConfig.actions';
import { selectBrokerFormConfigData } from 'src/app/state/selectors/brokerFormConfig.selector';
import { selectBrokerConfigData } from 'src/app/state/selectors/brokerConfig.selector';
import { loadBrokerFormConfigData } from 'src/app/state/actions/brokerFormConfig.actions';
declare var $: any;

@Component({
  selector: 'app-edit-advisor',
  templateUrl: './edit-advisor.component.html',
  styleUrls: ['./edit-advisor.component.css'],
  providers: [DatePipe, PhoneFormatPipe],
  // providers: [DatePipe,PhoneFormatPipe,salesTrackingFormater,SalestrackingcodePipe],
})
export class EditAdvisorComponent implements OnInit {
  adminName: any;
  public id: string;
  streetAddressline1: any;
  streetAddressline2: any;
  primaryPhone: any;
  secondaryPhone: any;
  primaryEmail: any;
  secondaryEmail: any;
  thirdEmail: any;
  country: any;
  city: any;
  state: any;
  postalCode: any;
  showaddadmin = true;
  showformtype = false;
  showaddform = false;
  addlicenseform = true;
  isEditable = true;
  enableEditIndex = null;
  todayDate: any;
  planLevels: any;
  uploadFormlogo: any;
  isEditableForm = true;
  enableEditIndexForm = null;
  brokersalesCodes: Array<any> = [];
  salesTrackingCode: any
  editbrokerEOinfo: any;
  editEOinsurerName: any;
  editEOpolicy: any;
  editEOcertificate: any;
  editEOExpiryDate: any;
  isEditableEO = true;
  enableEditIndexEO = null;
  showFormsDetails = true;
  shortNameValue: any;
  editFormType: any;
  editFormDetails: any;
  editFormName: any;
  brokerinfobrokerType: any;
  parentBrokerId: any;
  parentBrokerName: any;
  brokerinfoName: any;
  brokerinfoName1: any;
  brokerid: any;
  editFormDescription: any;
  editFormlink: any;
  editFormlogo: any;
  editFormPricingOptions: any
  brokerlicensedetails: any
  editFormDisclousreAggrement: any;
  showparentdisclosurecondition = false;
  addlicenseformtable = false;
  addlicenseformData: Array<any> = [];
  addformDetails: Array<any> = [];
  productsArrayList: Array<any> = [];
  fromplansarry: Array<any> = [];
  editindex: any;
  groupContactId: any;
  groupAdminId: any;
  showimagelogo = true;
  showdisclosureaggrement = true;
  showparentlogocondition = false;
  imagedisplaypdf: any;
  editbrokerlicensenumber: any;
  editbrokerlicensecoverage: any;
  editbrokerlicensestate: any;
  editbrokerlicenseexpirydate: any;
  editbrokerlicenseexpiryremainder: any;
  editSalesTrackingCode: any;
  editSalesTrackingName: any;
  editSalesTrackingType: any;
  editSalesTrackingPercentage: any;
  configprovinceres: any;
  enrollmentDates: any;
  imagedisplay: any;
  provincialHealthcareUrl: any;
  provincialZipcodes: any;
  SignupFormData: Array<any> = [];
  licensesInfo: Array<any> = [];
  EOinsurenceInfo: any;
  provincelistid: any;
  insurancestate_id: any;
  insurancestatename: any;
  licenseData: any;
  state_id: any;
  statename: any;
  serverUrl: any;
  public postalvalue: any;
  brokerData: Array<any> = [];
  allBrokers: Array<any> = [];
  licenseCoverage: Array<any> = [];
  brokerType: Array<any> = [];
  formType: Array<any> = [];
  uploaddisclousreAggrement: any;
  productsArray: Array<any> = [];
  advisorGroupContact: Array<any> = [];
  pricingOptions: Array<any> = [];
  uploadlogo: any;
  showBusinessnumber: boolean = false;
  customForm: boolean = false;
  public invalidpostalcodeprivince: boolean = false;
  public allplansArray: Array<any> = [];
  public plansIds = [];
  public showPlans: any;
  public plansError: boolean = false;
  public saveError: boolean = false
  public showaddprofileData: boolean = false
  formTitle: any;
  role = sessionStorage.getItem('role');
  formDescription: any
  showlicenseForm = false;
  showEOForm = false;
  brokerLicensedStatesAndProvinces: Array<any> = [];
  brokerEOinformation: Array<any> = [];
  salesTrackingCodeShares: Array<any> = [];
  brokerFormData: Array<any> = [];
  brokerAdmins: Array<any> = [];
  globalbrokerFormData: Array<any> = [];
  brokerContactInfo: Array<any> = [];
  adminData: any;
  adminSahredData: Array<any> = [];
  addadminform = false;
  showSharedAdvisorData: boolean = true;
  @ViewChild('multiSelectDropdown') multiSelectDropdown: any;

  brokerregform: FormGroup = new FormGroup({
    ParentbrokerName: new FormControl(''),
    brokerCount: new FormControl(''),
    brokerName: new FormControl(''),
    brokerType: new FormControl(''),
    businessnumber: new FormControl(''),
    streetAddress: new FormControl(''),
    streetAddress2: new FormControl(''),
    primaryPhone: new FormControl(''),
    secondaryPhone: new FormControl(''),
    primaryEmail: new FormControl(''),
    secondaryEmail: new FormControl(''),
    thirdEmail: new FormControl(''),
    country: new FormControl(''),
    city: new FormControl(''),
    Province: new FormControl(''),
    postalCode: new FormControl(''),
    InsuranceName: new FormControl(''),
    policyNumber: new FormControl(''),
    certificateName: new FormControl(''),
    Insuranceexpiry: new FormControl(''),
    salesTrackingCode: new FormControl(''),
    salesTrackingDescription: new FormControl(''),
    parentlogo: new FormControl(''),
    parentdisclosure: new FormControl(''),
    logo: new FormControl(''),
    disclosureAgreement: new FormControl(''),
    signupForm: new FormControl(''),

    formName: new FormControl(''),
    formDescription: new FormControl(''),
    formLink: new FormControl(''),
  });
  brokerSharedregform: FormGroup = new FormGroup({
    ParentbrokerName: new FormControl(''),
    brokerName: new FormControl(''),
    brokerType: new FormControl(''),
    businessnumber: new FormControl(''),
    streetAddress: new FormControl(''),
    streetAddress2: new FormControl(''),
    primaryPhone: new FormControl(''),
    secondaryPhone: new FormControl(''),
    primaryEmail: new FormControl(''),
    secondaryEmail: new FormControl(''),
    thirdEmail: new FormControl(''),
    country: new FormControl(''),
    city: new FormControl(''),
    Province: new FormControl(''),
    postalCode: new FormControl(''),


    formName: new FormControl(''),
    formDescription: new FormControl(''),
    formLink: new FormControl(''),
  });
  adminform: FormGroup = new FormGroup({
    firstName: new FormControl(''),
    lastName: new FormControl(''),
    phoneNum: new FormControl(''),
    email: new FormControl(''),
    role: new FormControl(''),
    roleName: new FormControl(''),
  });
  licenseform: FormGroup = new FormGroup({
    licenseNumber: new FormControl(''),
    licenseCoverage: new FormControl(''),
    state: new FormControl(''),
    expiryDate: new FormControl(''),
    remainder_days: new FormControl(''),
  });
  eoform: FormGroup = new FormGroup({
    insurerName: new FormControl(''),
    policyNumber: new FormControl(''),
    certificateNumber: new FormControl(''),
    expiryDate: new FormControl('')
  });


  formCreation: FormGroup = new FormGroup({
    profileName: new FormControl(''),
    Signupformtype: new FormControl(''),
    formName: new FormControl(''),
    formDescription: new FormControl(''),
    formlink: new FormControl(''),
    formlogo: new FormControl(''),
    formplanLevels: new FormControl(''),
    formdisclosureAgreement: new FormControl(''),
    pricingOptions: new FormControl('')

  });
  ShowOthers: boolean = false;
  prevSTC: any;
  brokerProfileslist: any[];
  showSharedBrokerList: boolean = false;
  existBrokerName: any;
  licenseCoverageList: any;
  showsalestrackinCodeAuto: boolean = false;
  allBrokersUnique: Array<any> = []; getsharedexisting: any;
  profileBasedOriginalId: any;
  editFormProfile: any;
  showsharedformData: boolean = false;
  brokerTypeName: any;
  public chart: any;
  private chartInfo: any;
  private labeldata: any[] = [];
  private realdata: any[] = [];
  totalValue: any = 0;
  editbrokerlicenseshortName: any = '';
  addlicenseformDataShared: Array<any> = [];
  fusebillId: any;
  provinceshortName: any;
  showaddEOdetails = false;
  addEOform = true;    // changeDetector: any;
  showSelectdAdvsiors: any[];
  public lang: any = {};
  selectedLanguage: string;
  languageData: any;
  loading$: Observable<boolean>;
  error$: Observable<string | null>;
  advisorData$: Observable<any>;
  brokerList: any = [];
  languageData$: Observable<any>;
  brokerConfigData$: Observable<any>;
  brokerConfigData: any = {}
  brokerFormConfigData$: Observable<any>;
  brokerFormConfigData: any = {}
  private destroy$ = new Subject<void>();
  showaddplans:boolean = false;
  showeditplans:boolean = false;
  selectedPlanLevels:any = [];

  constructor(
    public _LoaderService: LoaderService,
    public router: Router,
    private route: ActivatedRoute,
    private http: HttpClient,
    private formBuilder: FormBuilder,
    public elementRef: ElementRef,
    private datePipe: DatePipe,
    private cdr: ChangeDetectorRef,
    private _clipboardService: ClipboardService,
    private toastrService: ToastrService,
    private phoneNoFormat: PhoneFormatPipe,
    private elRef: ElementRef, private renderer: Renderer2,
    private commonPatternsService: CommonPatternsService,
    private store: Store<{ advisorData: [], languageData: [], brokerConfigData: {}, brokerFormConfigData: {} }>
  ) {
    this.advisorData$ = store.select(selectAdvisorData);
    this.loading$ = store.select(selectAdvisorLoading);
    this.error$ = store.select(selectAdvisorError);
    this.languageData$ = store.select(selectLanguageData);
    this.brokerFormConfigData$ = store.select(selectBrokerFormConfigData)
    this.brokerConfigData$ = store.select(selectBrokerConfigData)
   }
  dropdownList = [];
  selectedItems = [];
  dropdownSettings = {};
  dropdownSettings1 = {};
  ngOnInit() {
    setTimeout(()=>{
      sessionStorage.setItem('pageName', 'Edit Advisor');
    },100)
    this.getLanguageTokens()

    this.dropdownSettings1 = {
      singleSelection: false,
      // closeDropDownOnSelection: true,
      idField: 'id',
      textField: 'name',
      selectAllText: 'Select All',
      unSelectAllText: 'Deselect All',
      itemsShowLimit: 4,
      allowSearchFilter: true,
    };


    this.adminData = []
    this.serverUrl = environment.apiUrl
    this.todayDate = new Date()
    this.adminName = sessionStorage.getItem('adminName');


    this.dropdownList = [
      { item_id: 1, item_text: 'Mumbai' },
      { item_id: 2, item_text: 'Bangaluru' },
      { item_id: 3, item_text: 'Pune' },
      { item_id: 4, item_text: 'Navsari' },
      { item_id: 5, item_text: 'New Delhi' }
    ];

    this.dropdownSettings = {
      singleSelection: false,
      idField: 'id',
      textField: 'name',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 3,
      allowSearchFilter: true
    };
    this.brokerregform = this.formBuilder.group({
      ParentbrokerName: [''],
      brokerCount: [''],
      brokersName: [
        '',
        [
          Validators.required,
          Validators.minLength(1),
          Validators.maxLength(255),
        ],
      ],
      brokerType: ['', [Validators.required]],
      businessnumber: [''],
      streetAddress: ['', [Validators.required]],
      streetAddress2: [''],
      primaryPhone: [
        '',
        [
          Validators.required,
          Validators.minLength(17),
          Validators.maxLength(17),
        ],
      ],
      secondaryPhone: [
        '',
        [
          Validators.minLength(17),
          Validators.maxLength(17),
        ],
      ],
      primaryEmail: [
        '',
        [
          Validators.required,
          Validators.pattern(this.commonPatternsService.emailPattern),
        ],
      ],
      secondaryEmail: [
        '',
        [
          Validators.pattern(this.commonPatternsService.emailPattern),
        ],
      ],
      thirdEmail: [
        '',
        [
          Validators.pattern(this.commonPatternsService.emailPattern),
        ],
      ],
      country: ['', [Validators.required]],
      city: ['', [Validators.required]],
      Province: ['', [Validators.required]],
      postalCode: ['', [Validators.required, Validators.compose([postalcodeValidator])]],
      InsuranceName: [''],
      policyNumber: [''],
      certificateName: [''],
      Insuranceexpiry: [''],
      salesTrackingCode: [''],
      salesTrackingDescription: [''],
      brokerShare: ['false'],
      brokerStatus: ['false'],
      parentlogo: [''],
      parentdisclosure: [''],
      logo: [''],
      disclosureAgreement: [''],
      signupForm: [''],
    });
    this.brokerSharedregform = this.formBuilder.group({
      brokerStatus: [''],
      ParentbrokerName: ['', [Validators.required]],

      brokersName: [''],
      // brokerType: ['', [Validators.required]],
      // businessnumber: [''],
      // streetAddress: ['', [Validators.required]],
      // streetAddress2: [''],
      // primaryPhone: [
      //   '',
      //   [
      //     Validators.required,
      //     Validators.minLength(17),
      //     Validators.maxLength(17),
      //   ],
      // ],
      // secondaryPhone: [
      //   '',
      //   [Validators.minLength(17), Validators.maxLength(17)],
      // ],
      // primaryEmail: [
      //   '',
      //   [
      //     Validators.required,
      //     Validators.pattern(this.commonPatternsService.emailPattern),
      //   ],
      // ],
      // secondaryEmail: [
      //   '',
      //   [Validators.pattern(this.commonPatternsService.emailPattern)],
      // ],
      // thirdEmail: [
      //   '',
      //   [Validators.pattern(this.commonPatternsService.emailPattern)],
      // ],
      // country: ['canada', [Validators.required]],
      // city: ['', [Validators.required]],
      // Province: ['', [Validators.required]],
      // postalCode: [
      //   '',
      //   Validators.compose([Validators.required, postalcodeValidator]),
      // ]
    });
    this.adminform = this.formBuilder.group({
      firstName: [
        '',
        [
          Validators.required,
          Validators.minLength(1),
          Validators.maxLength(20),
        ],
      ],
      lastName: [
        '',
        [
          Validators.required,
          Validators.minLength(1),
          Validators.maxLength(20),
        ],
      ],
      phoneNum: [
        '',
        [
          Validators.required,
          Validators.minLength(17),
          Validators.maxLength(17),
        ],
      ],
      email: [
        '',
        [
          Validators.required,
          Validators.pattern(this.commonPatternsService.emailPattern),
        ],
      ],
      role: ['', [Validators.required]],
      roleName: ['']
    });

    this.licenseform = this.formBuilder.group({
      licenseNumber: [
        '',
        [
          Validators.required,
          Validators.minLength(3),
          Validators.maxLength(100),
        ],
      ],
      licenseCoverage: ['', [Validators.required]],
      state: ['', [Validators.required]],
      expiryDate: ['', [Validators.required]],
      remainder_days: ['', [Validators.required]],
    });
    this.eoform = this.formBuilder.group({
      insurerName: [
        '',
        [
          Validators.required,
          Validators.minLength(1),
          Validators.maxLength(100),
        ],
      ],
      policyNumber: ['', [Validators.required]],
      certificateNumber: ['', [Validators.required]],
      expiryDate: ['', [Validators.required]],
    });



    this.formCreation = this.formBuilder.group({
      profileName: ['', [Validators.required]],
      Signupformtype: [''],
      formName: ['', [Validators.required]],
      formDescription: ['', [Validators.required]],
      formlink: [''],
      formlogo: [''],
      formplanLevels: [''],
      pricingOptions: ['']


    });

    this.id = this.route.snapshot.paramMap.get('id');

    // this.productsArray = [{ "id": "3", "name": "Classic Bronze" }, { "id": "4", "name": "Classic Silver" }, { "id": "7", "name": "All-In Bronze" }, { "id": "8", "name": "All-In Silver" }]



    this.formConfig()
    // this.getBrokerDetails()
    // this.getServiceWorkerDetails()
    this.store.dispatch(loadAdvisorData());
    this.advisorData$ = this.store.select(state => state.advisorData).pipe(
      // startWith([]),
      // takeUntil(this.destroy$)
    );
    this.advisorData$.subscribe(data => {
      if (data) {
        console.log(data)
      if (data?.advisorData == undefined || Object.keys(data.advisorData).length <= 0) {
        console.log('No data to process', new Date().toISOString());
        return;
      }
      if(this.brokerList.length>0){
        return;
      }
      this.brokerList = data.advisorData
      this.brokerList = this.brokerList.map((broker)=>{
        return{
          ...broker,
          published: !broker.published || broker.published == undefined || broker.published == null ? 'Inactive' : 'Active'
        }
      })
      } else {
        console.error('Observable returned undefined');
      }
    })
  }

  public getLanguageTokens() {
    // let body = {
    //   "project": "Admin Portal",
    //   "url": "editAdvisor"
    // }
    // this.http
    //   .post('https://languageengineapi.aitestpro.com/string/project-url-strings', body, {
    //     headers: {
    //       'Content-Type': 'application/json',
    //     },
    //   })
    //   .subscribe(
    //     (response: any) => {
    //       console.log(response)
    //       this.lang = {};
    //       this.languageData = response.strings
    //       this.selectedLanguage = sessionStorage.getItem("language")
    //       for (let token of response.strings) {
    //         this.lang[token.key] = token[this.selectedLanguage];
    //       }
    //       console.log(this.lang)
    //     })

    // this.store.dispatch(loadLanguageData());

    this.languageData$ = this.store.select(state => state.languageData).pipe(
      startWith([]),
      takeUntil(this.destroy$)
    );

    this.languageData$.subscribe(data => {
      if(data){
        // console.log(data)
        if (data?.languageData == undefined || Object.keys(data.languageData).length <= 0) {
          console.log('No data to process', new Date().toISOString());
          return;
        }
        // if(Object.keys(this.lang).length>0){
        //   return;
        // }
        setTimeout(()=>{
          this.lang = {};
          this.languageData = data?.languageData
          this.selectedLanguage = sessionStorage.getItem("language")
          for (let token of data?.languageData) {
            this.lang[token.key] = token[this.selectedLanguage];
          }
          // console.log('this.lang',this.lang)
        },0)
      }
    })
  }
  multiSelectAdvsiorSelect(event: any) {
    //convert number into string?
    console.log(event);
    // this.multiSelectProviance.push(event.id);
    // this.multiSelectProviancenames.push(event)

    this.brokersalesCodes.push({
      brokerId: event.id,
      brokerName: event.name,
      commission: '',
    });

    // this.showsharedExistingButton =true
    this.showsalestrackinCodeAuto = true;

    console.log(this.brokersalesCodes)
    // $("#BrokerSharedNewDetails").hide()


    if (this.brokersalesCodes.length == this.broker['brokerCount'].value) {
      this.showSharedBrokerList = false
    }
    else {
      this.showSharedBrokerList = true
    }

    this.broker['brokerCount'].setValue(this.brokersalesCodes.length - 1);
  }
  closemultiSelectAdvisorList() {
    if (this.multiSelectDropdown) {
      this.multiSelectDropdown.closeDropdown();
      $("#BrokerSharedNewDetails").hide()
    }
  }
  multiSelectAdvisorSelectAll(event: any) {
    console.log(event);
    this.brokersalesCodes = [];
    // this.multiSelectProviancenames = [];
    event.forEach((data: any) => {
      // console.log(proviance)
      // this.multiSelectProviance.push(proviance.id);
      this.brokersalesCodes.push({ "brokerId": data.id, "brokerName": data.name, "commission": '' });


    });
    console.log(this.brokersalesCodes)
    this.broker['brokerCount'].setValue(this.brokersalesCodes.length - 1);

    this.closemultiSelectAdvisorList();
  }

  checkRole(event: any) {
    console.log(event.target.value)

  }


  multiSelectAdvisorItemDeSelect(event: any) {
    console.log(event);
    let indexOf = this.brokersalesCodes.indexOf(event.id);
    this.brokersalesCodes.splice(indexOf, 1);
    // this.multiSelectProviancenames.splice(indexOf, 1);

    console.log(this.brokersalesCodes);

    if (this.brokersalesCodes.length == 0) {
      // this.showsharedExistingButton =false

    }
    this.broker['brokerCount'].setValue(this.brokersalesCodes.length - 1);

  }
  multiSelectAdvisorDeSelectAll(event: any) {
    console.log(event);
    this.brokersalesCodes = [];
    // this.multiSelectProviancenames = [];
    console.log(this.brokersalesCodes);
    // this.showsharedExistingButton =false
    this.broker['brokerCount'].setValue(this.brokersalesCodes.length - 1);

  }
  getBrokerProfiles(brokerId) {
    var endPoint = '/api/ap/broker/' + brokerId + '/profiles';
    var accessToken = sessionStorage.getItem('accessToken');

    this.http
      .get(environment.apiUrl + endPoint, {
        headers: {
          Authorization: 'Bearer ' + accessToken,
          'Content-Type': 'application/json',
        },
      })
      .subscribe((response: any) => {
        if (response['status'] == 200) {
          this.brokerProfileslist = this.parseAllValuesInArray(response.data.profiles);
          console.log(this.brokerProfileslist)
        }
      });
  }
  getProfilebasedid(event) {
    console.log(event);
    this.profileBasedOriginalId = +event.target.value;
  }

  parseAllValuesInArray(arr: any[]): any[] {
    return arr.map(obj => {
      const parsedObj: any = {};
      for (const key in obj) {
        if (obj.hasOwnProperty(key)) {
          try {
            parsedObj[key] = JSON.parse(obj[key]);
          } catch (e) {
            parsedObj[key] = obj[key]; // If parsing fails, retain original value
          }
        }
      }
      return parsedObj;
    });
  }
  disableScrolling(): void {
    const container = this.elRef.nativeElement.querySelector('.form-container');
    if (container) {
      this.renderer.setStyle(container, 'overflow-y', 'hidden');
    }
  }

  enableScrolling(): void {
    const container = this.elRef.nativeElement.querySelector('.form-container');
    if (container) {
      this.renderer.setStyle(container, 'overflow-y', 'auto');
    }
  }



  // getServiceWorkerDetails() {
  //   var GetBrokersDetails = '/api/ap/broker/' + this.route.snapshot.params['id'] + '/details';


  //   let prefetchurls = []

  //   let Data = [{
  //     url: environment.apiUrl + GetBrokersDetails,
  //     // fetch options
  //     options: {

  //       mode: 'cors',
  //       headers: {

  //         Authorization: 'Bearer ' + sessionStorage.getItem('accessToken'),
  //         'Content-Type': 'application/json',
  //       }
  //     }
  //   }]
  //   prefetchurls = Data

  //   postServiceWorkerMessage(WorkerMessageType.Prefetch, prefetchurls).then((results: WorkerUrlPrefetchResult) => {


  //     this.brokerEOinformation = []
  //     let response = results[0].response

  //     let licenseData = response.data.brokerLicensedStatesAndProvinces


  //     for (let i = 0; i < licenseData.length; i++) {

  //       licenseData[i].expiryDate = this.datePipe.transform(
  //         licenseData[i].expiryDate,
  //         'MMM-dd-yyyy'
  //       )
  //     }

  //     if (licenseData.length == 0) {
  //       this.showlicenseForm = true
  //     }
  //     else {
  //       this.showlicenseForm = false
  //     }

  //     let licenseEO = response.data.brokerEoInsurance

  //     const isObjectEmpty = (objectName) => {
  //       return Object.keys(objectName).length === 0
  //     }


  //     if (isObjectEmpty(licenseEO) == true) {
  //       this.showEOForm = true
  //     }
  //     else {
  //       this.showEOForm = false
  //     }


  //     licenseEO['expiryDate'] = this.datePipe.transform(
  //       response.data.brokerEoInsurance.expiryDate,
  //       'MMM-dd-yyyy'

  //     )

  //     this.salesTrackingCodeShares = response.data.salesTrackingCodeShares
  //     this.brokerEOinformation.push(licenseEO)



  //     this.brokerLicensedStatesAndProvinces = licenseData

  //     this.brokerFormData = response.data.signupForms ?? [];

  //     console.log("gettingBrokerData")
  //     console.log("gettingBrokerData " + this.brokerFormData.length)
  //     console.log("formsData", this.brokerFormData)

  //     this.parentBrokerId = response.data.parentId
  //     this.parentBrokerName = response.data.parent.name
  //     console.log(this.parentBrokerName, "name")
  //     this.globalbrokerFormData = response.data.signupForms ?? []

  //     this.adminData = response.data.brokerAdmins;
  //     console.log(this.adminData, "response")

  //     if (this.adminData.length > 0) {
  //       this.addadminform = false
  //       this.showaddadmin = true
  //     }
  //     else {
  //       this.addadminform = true
  //       this.showaddadmin = false
  //     }


  //     this.brokerContactInfo.push(response.data.contactInfo ? response.data.contactInfo : '')

  //     this.streetAddressline1 = this.brokerContactInfo[0].line1
  //     this.streetAddressline2 = this.brokerContactInfo[0].line2
  //     this.primaryPhone = this.brokerContactInfo[0].primaryPhone
  //     this.secondaryPhone = this.brokerContactInfo[0].secondaryPhone
  //     this.primaryEmail = this.brokerContactInfo[0].primaryEmail
  //     this.secondaryEmail = this.brokerContactInfo[0].secondaryEmail.split(",")[0]
  //     if (this.brokerContactInfo[0].secondaryEmail.split(",") > 1) {
  //       this.thirdEmail = this.brokerContactInfo[0].secondaryEmail.split(",")[1]
  //     }
  //     this.country = this.brokerContactInfo[0].country
  //     this.city = this.brokerContactInfo[0].city
  //     this.state = this.brokerContactInfo[0].state
  //     this.postalCode = this.brokerContactInfo[0].postalCode
  //     this.brokerinfobrokerType = response.data.brokerType

  //     this.brokerinfoName = response.data.name

  //     this.brokerid = response.data.id

  //     console.log(this.brokerLicensedStatesAndProvinces)
  //     if (this.brokerFormData && this.brokerFormData.length > 0) {
  //       this.showFormsDetails = true;
  //       this.showaddform = false;
  //     }
  //     else {
  //       this.initializePlansArray(this.productsArray, false, false, 'CUSTOM')
  //       this.showFormsDetails = false
  //       this.showaddform = true;
  //       this.showPlans = true;
  //     }



  //   })
  // }

  getBrokerDetails() {

    this.brokerEOinformation = []
    console.log(this.route.snapshot.params['id'])
    // let broker= broker.id
    var accessToken = sessionStorage.getItem('accessToken');
    // var GetBrokersDetails = '/api/ap/broker/' + this.route.snapshot.params['id'] + '/details';
    var GetBrokersDetails = '/api/ap/broker/' + this.route.snapshot.params['id'] + '/details/first';

    this.http
      .get(environment.apiUrl + GetBrokersDetails, {
        headers: {
          Authorization: 'Bearer ' + accessToken,
          'Content-Type': 'application/json',
        },
      })
      .subscribe(
        (response: any) => {
          console.log(response)
          if (response['status'] == 200 || response['statusCode'] == 200) {
            console.log(response)


            let licenseData = response.data.brokerLicensedStatesAndProvinces


            for (let i = 0; i < licenseData.length; i++) {

              licenseData[i].expiryDate = this.datePipe.transform(
                licenseData[i].expiryDate,
                'MM-dd-yyyy'
              )
            }

            if (licenseData.length == 0) {
              this.showlicenseForm = true
            }
            else {
              this.showlicenseForm = false
            }

            let licenseEO = response.data.brokerEoInsurance

            const isObjectEmpty = (objectName) => {
              return Object.keys(objectName).length === 0
            }


            if (isObjectEmpty(licenseEO) == true) {
              this.showEOForm = true
            }
            else {
              this.showEOForm = false
            }


            licenseEO['expiryDate'] = this.datePipe.transform(
              response.data.brokerEoInsurance.expiryDate,
              'MM-dd-yyyy'

            )

            this.salesTrackingCodeShares = response.data.salesTrackingCodeShares
            this.brokerEOinformation.push(licenseEO)



            this.brokerLicensedStatesAndProvinces = licenseData

            // this.brokerFormData = response.data.signupForms ?? [];
            this.brokerFormData = response.data.forms ?? [];
            setTimeout(() => {
              this.brokerProfileslist = []
              this.getBrokerProfiles(this.route.snapshot.params['id'])
            }, 1000);

            console.log("gettingBrokerData")
            console.log("gettingBrokerData " + this.brokerFormData.length)
            console.log("formsData", this.brokerFormData)

            this.parentBrokerId = response.data.parentId
            this.parentBrokerName = response.data.parent?.name

            // this.globalbrokerFormData = response.data.signupForms ?? []
            this.globalbrokerFormData = response.data.forms ?? []

            this.adminData = response.data.brokerAdmins;
            console.log(this.adminData, "response")

            if (this.adminData.length > 0) {
              this.addadminform = false
              this.showaddadmin = true
            }
            else {
              this.addadminform = true
              this.showaddadmin = false
            }


            this.brokerContactInfo.push(response.data.contactInfo ? response.data.contactInfo : '')

            this.streetAddressline1 = this.brokerContactInfo[0].line1
            this.streetAddressline2 = this.brokerContactInfo[0].line2
            this.primaryPhone = this.brokerContactInfo[0].primaryPhone
            this.secondaryPhone = this.brokerContactInfo[0].secondaryPhone
            this.primaryEmail = this.brokerContactInfo[0].primaryEmail

            if (this.brokerContactInfo[0].secondaryEmail && this.brokerContactInfo[0].secondaryEmail.split(",").length > 1) {
              this.secondaryEmail = this.brokerContactInfo[0].secondaryEmail.split(",")[0]
              this.thirdEmail = this.brokerContactInfo[0].secondaryEmail.split(",")[1]
            } else {
              this.secondaryEmail = this.brokerContactInfo[0].secondaryEmail
            }
            // console.log(this.secondaryEmail, this.thirdEmail, this.brokerContactInfo[0].secondaryEmail.split(","), this.brokerContactInfo[0].secondaryEmail.split(",") > 1)
            this.country = this.brokerContactInfo[0].country
            this.city = this.brokerContactInfo[0].city
            this.state = this.brokerContactInfo[0].state
            this.postalCode = this.brokerContactInfo[0].postalCode
            this.brokerinfobrokerType = response.data.brokerType
            this.showBusinessnumber = (this.brokerinfobrokerType === 'BROKERAGE');


            this.brokerinfoName = response.data.name
            this.brokerinfoName1 = response.data.name

            this.brokerid = response.data.id

            console.log(this.brokerLicensedStatesAndProvinces)
            if (this.brokerFormData && this.brokerFormData.length > 0) {
              this.showFormsDetails = true;
              this.showaddform = false;
            }
            else {
              console.log(this.productsArray)

              if (this.productsArray.length > 0) {
                this.initializePlansArray(this.productsArray, false, false, 'CUSTOM')
                this.showFormsDetails = false
                this.showaddform = true;
                this.showPlans = true;
              }
            }

          } else {
            Swal.fire({ title: 'Error', text: response.message })
          }
          this.cdr.markForCheck();

        },
        (error) => {
          if (
            error.status == 400 ||
            error.status == 401 ||
            error.status == 402 ||
            error.status == 403
          ) {
            Swal.fire({
              title: 'Error',
              text: error.error.error.message,
              showDenyButton: false,
              showCancelButton: false,
              confirmButtonText: 'OK',
            }).then((result) => {
              /* Read more about isConfirmed, isDenied below */
              if (result.isConfirmed) {
                sessionStorage.clear();
                this.router.navigate(['/login']);
              }
              else {
                sessionStorage.clear();
                this.router.navigate(['/login']);
              }
            });
          } else {
            // Swal.fire(error.error.error.message)
            Swal.fire({ title: 'Error', text: error.error.error.message });
          }
          // this.toastrService.error("Invalid Credentials", 'Error!');
        }
      );
  }

  showBrokerDetails() {
    this.showPlans = false;
  }

  getbrookercount(e: any) {

    this.showSharedBrokerList = true
    // if(this.brokersalesCodes.length==this.broker['brokerCount'].value){
    //   this.showSharedBrokerList =false
    // }
    // else{
    //   if(this.brokersalesCodes.length>this.broker['brokerCount'].value){
    //     Swal.fire({
    //       title: 'Info',
    //       text: "Shared broker list not matching with no.of brokers count",
    //     });
    //     this.showSharedBrokerList =false
    //     return false
    //   }
    //   else{
    //     this.showSharedBrokerList =true
    //   }

    // }
  }

  public getBrokerSharedExisting(broker: any) {

    console.log(this.getsharedexisting)
    this.brokersalesCodes.push({
      brokerId: this.getsharedexisting.id,
      brokerName: this.getsharedexisting.name,
      commission: '',
    });
    // this.showsalestrackinCodeAuto = true;
    console.log(this.brokersalesCodes)
    // $("#BrokerSharedNewDetails").hide()

    console.log(+this.broker['brokerCount'].value + 1)

    if (this.brokersalesCodes.length == +this.broker['brokerCount'].value + 1) {
      this.showSharedBrokerList = false
      this.showaddprofileData = false
    }
    else {
      this.showSharedBrokerList = true
      // this.showaddprofileData =true

    }


  }
  checkAdvsiorNameExist() {
    let advsior = this.broker['brokersName'].value;
    let accessToken = sessionStorage.getItem('accessToken');
    let endPoint = '/api/ap/broker/validateName';
    let inputData = {
      'name': advsior,
      'description': ''
    }
    this.http.post(environment.apiUrl + endPoint, inputData, {
      headers: {
        Authorization: 'Bearer ' + accessToken,
        'Content-Type': 'application/json',
      }
    }).subscribe((response: any) => {
      if (response.status == '200') {//new corporate
        this.http.get(environment.apiUrl + '/api/ap/global/set-adminAdvisors').subscribe((newResponse) => {
          this.http.post(environment.reportApiUrl + '/websocket/advisor/notification-to-others', {
            "message": "Advisors information has been updated. Please refresh screen."
          }, {
            headers: {
              Authorization: 'Bearer ' + accessToken,
              'Content-Type': 'application/json',
            }
          }).subscribe((res) => {
            console.log({ res })
          })
        })
        return false;
      }
      else {//Already exist
        Swal.fire({ title: 'Info', text: response.message }).then((result) => {
          if (result.isConfirmed) {
            this.broker['brokersName'].setValue('');
          }
        });
      }
    }, (error) => {
      Swal.fire({ title: 'Error', text: error.message ?? error.error.message })
    })
  }
  checkAdvsiorNameExistshared() {
    let advsior = this.brokerShared['brokersName'].value;
    let accessToken = sessionStorage.getItem('accessToken');
    let endPoint = '/api/ap/broker/validateName';
    let inputData = {
      'name': advsior,
      'description': ''
    }
    this.http.post(environment.apiUrl + endPoint, inputData, {
      headers: {
        Authorization: 'Bearer ' + accessToken,
        'Content-Type': 'application/json',
      }
    }).subscribe((response: any) => {
      if (response.status == '200') {//new corporate
        this.http.get(environment.apiUrl + '/api/ap/global/set-adminAdvisors').subscribe((newResponse) => {
          this.http.post(environment.reportApiUrl + '/websocket/advisor/notification-to-others', {
            "message": "Advisors information has been updated. Please refresh screen."
          }, {
            headers: {
              Authorization: 'Bearer ' + accessToken,
              'Content-Type': 'application/json',
            }
          }).subscribe((res) => {
            console.log({ res })
          })
        })
        return false;
      }
      else {//Already exist
        Swal.fire({ title: 'Info', text: response.message }).then((result) => {
          if (result.isConfirmed) {
            this.broker['brokersName'].setValue('');
          }
        });
      }
    }, (error) => {
      Swal.fire({ title: 'Error', text: error.message ?? error.error.message })
    })
  }
  public checkCommisionCode(event: any) {
    console.log(this.brokersalesCodes)
    this.labeldata = []
    this.realdata = []
    // if (this.brokersalesCodes.length == +this.broker['brokerCount'].value + 1) {
    const totalValue = this.brokersalesCodes.reduce((sum, item) => sum + +item.commission, 0);

    console.log(totalValue); // Output: 100

    if (totalValue === 100) {
      // this.showsharedformData =true

      this.checkAdvsiorSharedNameExist()
    }
    else {
      this.showsharedformData = false
      //  this.showaddprofileData =true
    }
    // }

    let data = this.brokersalesCodes
    for (let i = 0; i < data.length; i++) {
      this.labeldata.push(data[i].brokerName);
      this.realdata.push(data[i].commission);
      // this.colordata.push(this.chartInfo[i].colorcode);
    }




    this.createChart(this.labeldata, this.realdata);

  }
  checkAdvsiorSharedNameExist() {
    const convertedItems = this.brokersalesCodes.map(item => ({
      ...item,
      commission: Number(item.commission)
    }));
    let advsior = this.broker['brokersName'].value;
    let accessToken = sessionStorage.getItem('accessToken');
    let endPoint = '/api/ap/broker/validateShares';
    let inputData = {
      "brokerDetails": convertedItems,

    }
    this.http.post(environment.apiUrl + endPoint, inputData, {
      headers: {
        Authorization: 'Bearer ' + accessToken,
        'Content-Type': 'application/json',
      }
    }).subscribe((response: any) => {
      if (response.status == '200') {//new corporate
        this.showsharedformData = true
        // this.showaddprofileData=false;
        // this.brokerregform.reset()
        // this.broker['brokersName'].setValue('')
        return false;
      }
      else {//Already exist
        this.showsharedformData = false
        // this.showaddprofileData=true;
        Swal.fire({ title: 'Info', text: response.message }).then((result) => {
          if (result.isConfirmed) {
            // this.broker['brokersName'].setValue('');
          }
        });
      }
    }, (error) => {
      Swal.fire({ title: 'Error', text: error.message ?? error.error.message })
    })
  }
  checkformExist() {
    let addvisorformtitle = this.formCreation.value.formName;
    let accessToken = sessionStorage.getItem('accessToken');
    //localhost:3002/api/ap/admin/corporate/checkCorporateName'
    let endPoint = `/api/ap/broker/checkFormTitle`;
    let inputData = {

      "name": addvisorformtitle,
      "brokerId": this.brokerid
    }
    this.http.post(environment.apiUrl + endPoint, inputData, {
      headers: {
        Authorization: 'Bearer ' + accessToken,
        'Content-Type': 'application/json',
      }
    }).subscribe((response: any) => {
      if (response.status == '200') {//new corporate
        return false;
      }
      else {//Already exist
        Swal.fire({ title: 'Info', text: response.message }).then((result) => {

        });
      }
    }, (error) => {
      Swal.fire({ title: 'Error', text: error.message ?? error.error.message })
    })
  }
  groupContactChange(event: any) {
    if (event.target.value == 'ADVISOR_OTHERS') {
      this.ShowOthers = true;
      this.adminform.get('roleName').setValidators(Validators.required);
    }
    else {
      this.ShowOthers = false;
      this.adminform.get('roleName').clearValidators();
    }
    this.adminform.get('roleName').updateValueAndValidity();
  }

  get broker() {
    return this.brokerregform.controls;
  }
  get f() {
    return this.licenseform.controls;
  }
  get form() {
    return this.formCreation.controls;
  }
  get eo() {
    return this.eoform.controls;
  }
  get grpcontact() {
    return this.adminform.controls;
  }
  get brokerShared() {
    return this.brokerSharedregform.controls;


  }
  addadmin() {
    if (this.ShowOthers) {
      this.grpcontact['roleName'].markAsTouched();
    }
    if (this.adminform.invalid) {
      console.log(this.adminform);
      return;
    }
    console.log(JSON.stringify(this.adminform.value, null, 2));

    let obj = {
      firstName: this.capitalize(this.adminform.value.firstName),
      lastName: this.capitalize(this.adminform.value.lastName),
      phoneNum: this.adminform.value.phoneNum,
      email: this.adminform.value.email,
      role: this.adminform.value.role,
      id: this.brokerid,
      roleName: '' //this.adminform.value.role=='ADVISOR_OTHERS'?this.adminform.value.roleName:"",

    };
    if (obj.role == 'ADVISOR_OTHERS') {
      obj['roleName'] = this.adminform.value.roleName;
    } else {
      obj['roleName'] = "";

    }






    var addBrokerDetails = '/api/ap/v2/broker/' + this.brokerid + '/groupContact';
    var accessToken = sessionStorage.getItem('accessToken');

    this.http
      .post(environment.apiUrl + addBrokerDetails, obj, {
        headers: {
          Authorization: 'Bearer ' + accessToken,
          'Content-Type': 'application/json',
        },
      })
      .subscribe(
        (response: any) => {
          if (response['status'] == 200 || response['statusCode'] == 200) {
            this.adminData.push(obj);
            console.log(this.adminData, "admindata")

            this.adminform.reset();
            this.showaddadmin = true;
            this.addadminform = false;

            // if(obj.role=='ADVISOR_OTHERS')
            // obj['roleName']=this.adminform.value.roleName;
            // this.adminData.push(obj);

            this.adminform.reset();
            this.showaddadmin = true;
            this.addadminform = false;
            this.ShowOthers = false;

            this.http.get(environment.apiUrl + '/api/ap/global/set-adminAdvisors').subscribe((newResponse) => {
              this.http.post(environment.reportApiUrl + '/websocket/advisor/notification-to-others', {
                "message": "Advisors information has been updated. Please refresh screen."
              }, {
                headers: {
                  Authorization: 'Bearer ' + accessToken,
                  'Content-Type': 'application/json',
                }
              }).subscribe((res) => {
                console.log({ res })
              })
            })

            $('#basicModaladdgrpcontact').modal('hide');
            this.getBrokerDetails()
            // this.getServiceWorkerDetails()
          } else {
            Swal.fire({ title: 'Error', text: response.message })
          }
        },
        (error) => {
          if (
            error.status == 400 ||
            error.status == 401 ||
            error.status == 402 ||
            error.status == 403
          ) {
            Swal.fire({
              title: 'Error',
              text: error.error.error.message,
              showDenyButton: false,
              showCancelButton: false,
              confirmButtonText: 'Ok',
            }).then((result) => {
              /* Read more about isConfirmed, isDenied below */
              if (result.isConfirmed) {
                sessionStorage.clear();
                this.router.navigate(['/login']);
              }
              else {
                sessionStorage.clear();
                this.router.navigate(['/login']);
              }
            });
          } else {
            // Swal.fire(error.error.error.message)
            Swal.fire({ title: 'Error', text: error.error.error.message });
          }
        })



  }
  deleteadmin(admin, index: any) {

    Swal.fire({
      title: 'Alert',
      text: 'Are you sure you want to delete this Group Contact?',
      showDenyButton: false,
      showCancelButton: true,
      confirmButtonText: 'Proceed',
    }).then((result) => {
      /* Read more about isConfirmed, isDenied below */
      if (result.isConfirmed) {
        // const Data = this.adminData;
        // const removed = Data.splice(index, 1);


        var deletebroker = '/api/ap/broker/' + this.brokerid + '/groupContact/' + admin.userId + '';
        var accessToken = sessionStorage.getItem('accessToken');

        this.http
          .delete(environment.apiUrl + deletebroker, {
            headers: {
              Authorization: 'Bearer ' + accessToken,
              'Content-Type': 'application/json',
            },
          })
          .subscribe(
            (response: any) => {
              if (response['status'] == 200 || response['statusCode'] == 200) {
                this.http.get(environment.apiUrl + '/api/ap/global/set-adminAdvisors').subscribe((newResponse) => {
                  this.http.post(environment.reportApiUrl + '/websocket/advisor/notification-to-others', {
                    "message": "Advisors information has been updated. Please refresh screen."
                  }, {
                    headers: {
                      Authorization: 'Bearer ' + accessToken,
                      'Content-Type': 'application/json',
                    }
                  }).subscribe((res) => {
                    console.log({ res })
                  })
                })
                this.getBrokerDetails()
                // this.getServiceWorkerDetails()
              } else {
                Swal.fire({ title: 'Error', text: response.message })
              }
            },
            (error) => {
              if (
                error.status == 400 ||
                error.status == 401 ||
                error.status == 402 ||
                error.status == 403
              ) {
                Swal.fire({
                  title: 'Error',
                  text: error.error.error.message,
                  showDenyButton: false,
                  showCancelButton: false,
                  confirmButtonText: 'Ok',
                }).then((result) => {
                  /* Read more about isConfirmed, isDenied below */
                  if (result.isConfirmed) {
                    sessionStorage.clear();
                    this.router.navigate(['/login']);
                  }
                  else {
                    sessionStorage.clear();
                    this.router.navigate(['/login']);
                  }
                });
              } else {
                // Swal.fire(error.error.error.message)
                Swal.fire({ title: 'Error', text: error.error.error.message });
              }
            })

        if (this.adminData.length == 0) {
          this.addadminform = true;
          this.showaddadmin = false;
        }
        else {
          this.addadminform = false;
          this.showaddadmin = true;
        }



      }
    })

  }

  deleteadminShared(index: any) {
    Swal.fire({
      title: 'Alert',
      text: 'Are you sure you want to delete this Group Contact?',
      showDenyButton: false,
      showCancelButton: true,
      confirmButtonText: 'Proceed',
    }).then((result) => {
      /* Read more about isConfirmed, isDenied below */
      if (result.isConfirmed) {
        const Data = this.adminSahredData;
        const removed = Data.splice(index, 1);

        if (this.adminSahredData.length == 0) {
          this.addadminform = true;
          this.showaddadmin = false;
        } else {
          this.addadminform = false;
          this.showaddadmin = true;
        }
      }
    });
  }


  addadminShared() {
    if (this.adminform.invalid) {
      console.log(this.adminform);
      this.adminform.markAllAsTouched();
      return;
    }

    console.log(JSON.stringify(this.adminform.value, null, 2));
    let obj = {
      firstName: this.capitalize(this.adminform.value.firstName),
      lastName: this.capitalize(this.adminform.value.lastName),
      phoneNum: this.adminform.value.phoneNum,
      email: this.adminform.value.email,
      role: this.adminform.value.role,
    };
    if (obj.role == 'ADVISOR_OTHERS') {
      obj['roleName'] = this.adminform.value.roleName;
    } else {
      obj['roleName'] = "";

    }

    this.adminSahredData.push(obj);

    console.log(this.adminSahredData)

    this.adminform.reset();
    this.showaddadmin = true;
    this.addadminform = false;
    this.ShowOthers = false;

    $('#basicModaladdgrpcontactShared').modal('hide');
    $('#BrokerSharedNewDetails').modal('show');

    Swal.fire({
      title: 'Info',
      text: 'Group Admin Added Successfully',
    });
  }
  addEOformDetails() {
    if (this.eoform.invalid) {
      console.log(this.eoform.value);
      return;
    }
    console.log(JSON.stringify(this.eoform.value, null, 2));

    let obj = {
      insurerName: this.capitalize(this.eoform.value.insurerName),
      certificateNumber: this.eoform.value.certificateNumber,
      policyNumber: this.eoform.value.policyNumber,
      expiryDate:
        this.datePipe.transform(
          this.eoform.value.expiryDate,
          'MM-dd-yyyy'
        ) || '',
    };
    this.EOinsurenceInfo = obj;

    console.log(this.EOinsurenceInfo)

    this.addEOform = false;
    this.showaddEOdetails = true;
    this.eoform.reset();

    // $('#basicModal1').modal('hide');
  }

  brokerAdd() {

    // alert(this.brokerinfoName)
    // this.brokerinfoName =this.brokerinfoName
    this.showsalestrackinCodeAuto = true
    this.showaddprofileData = true
    if (this.brokersalesCodes.length == 0) {
      this.brokersalesCodes.push({
        brokerId: this.brokerid,
        brokerName: this.brokerinfoName,
        commission: '',
      });
    }

    const preservedValues = {
      brokerCount: this.brokerregform.get('brokerCount')?.value,
      brokerStatus: this.brokerregform.get('brokerStatus')?.value,


    };
    this.brokerregform.reset(preservedValues)
    this.adminform.reset()
    this.addadminform = true
    this.showaddadmin = false
    // $("#BrokerSharedNewDetails").show()
    // this.brokerregform.get('ParentbrokerName').setValue('');

  }

  editadminShared(admin: any, index: any) {
    console.log(admin);
    this.ShowOthers = admin.role == 'ADVISOR_OTHERS' ? true : false;
    console.log(this.adminform);
    this.editindex = index;
    this.adminform.patchValue(admin);
    this.groupContactId = admin.userId
    this.groupAdminId = admin.groupAdminId
  }
  editadmin(admin: any, index: any) {

    console.log(this.adminform)
    console.log(admin)
    this.ShowOthers = admin.role == "ADVISOR_OTHERS" ? true : false;
    this.adminform.patchValue(admin)

    console.log(this.adminform)
    this.editindex = index;
    this.groupContactId = admin.userId
    this.groupAdminId = admin.groupAdminId
  }
  editadminSubmit(admin) {
    console.log({ admin })
    if (this.ShowOthers) {
      this.grpcontact['roleName'].markAsTouched();
    }
    if (this.adminform.invalid) {
      console.log(this.adminform);
      return;
    }
    console.log(JSON.stringify(this.adminform.value, null, 2));

    let obj = { ...this.adminform.value }
    this.adminData[this.editindex] = this.adminform.value;
    obj['brokerAdminId'] = this.groupAdminId
    console.log(obj)

    this.adminform.reset();
    this.showaddadmin = true;
    this.addadminform = false;
    $('#basicModaleditgroupcontact').modal('hide');
    var editbroker = '/api/ap/v2/broker/' + this.brokerid + '/groupContact/' + this.groupContactId + '';
    var accessToken = sessionStorage.getItem('accessToken');

    this.http
      .put(environment.apiUrl + editbroker, obj, {
        headers: {
          Authorization: 'Bearer ' + accessToken,
          'Content-Type': 'application/json',
        },
      })
      .subscribe(
        (response: any) => {
          if (response['status'] == 200 || response['statusCode'] == 200) {
            this.http.get(environment.apiUrl + '/api/ap/global/set-adminAdvisors').subscribe((newResponse) => {
              this.http.post(environment.reportApiUrl + '/websocket/advisor/notification-to-others', {
                "message": "Advisors information has been updated. Please refresh screen."
              }, {
                headers: {
                  Authorization: 'Bearer ' + accessToken,
                  'Content-Type': 'application/json',
                }
              }).subscribe((res) => {
                console.log({ res })
              })
            })
            Swal.fire({ title: 'Info', text: "Group contact updated successfully" })

            this.getBrokerDetails()
            // this.getServiceWorkerDetails()
          } else {
            Swal.fire({ title: 'Error', text: response.message })
          }
        },
        (error) => {
          if (
            error.status == 400 ||
            error.status == 401 ||
            error.status == 402 ||
            error.status == 403
          ) {
            Swal.fire({
              title: 'Error',
              text: error.error.error.message,
              showDenyButton: false,
              showCancelButton: false,
              confirmButtonText: 'Ok',
            }).then((result) => {
              /* Read more about isConfirmed, isDenied below */
              if (result.isConfirmed) {
                sessionStorage.clear();
                this.router.navigate(['/login']);
              }
              else {
                sessionStorage.clear();
                this.router.navigate(['/login']);
              }
            });
          } else {
            // Swal.fire(error.error.error.message)
            Swal.fire({ title: 'Error', text: error.error.error.message });
          }
        })
    // $('#basicModal1').modal('hide');
  }
  editadminSubmitShared() {
    if (this.adminform.invalid) {
      this.adminform.markAllAsTouched();
      console.log(this.adminform);
      return;
    }
    console.log(JSON.stringify(this.adminform.value, null, 2));

    // let obj = {
    //   adminfirstname: this.capitalize(this.adminform.value.adminfirstname),
    //   lastName: this.capitalize(this.adminform.value.adminlastname),
    //   phoneNum: this.adminform.value.adminphone,
    //   email: this.adminform.value.adminemail,
    //   role: this.adminform.value.role,
    // };

    this.adminSahredData[this.editindex] = this.adminform.value;

    this.adminform.reset();
    this.showaddadmin = true;
    this.addadminform = false;
    this.editindex = null;
    $('#basicModaleditgroupcontactShared').modal('hide');
    $('#BrokerSharedNewDetails').modal('show');

    Swal.fire({
      title: 'Info',
      text: 'Group Admin Updated Successfully',
    });
    // $('#basicModal1').modal('hide');
  }
  hidegrpadmindetails() {
    this.adminform.reset();
  }
  saveLicense(license: any, index: number) {


    console.log(this.brokerLicensedStatesAndProvinces[index])

    //     console.log(license)


    var accessToken = sessionStorage.getItem('accessToken');
    var saveAdvisorlicense = '/api/ap/broker/' + license.brokerId + '/license/' + license.id + '';


    let licenseData = this.brokerLicensedStatesAndProvinces[index]

    console.log(this.insurancestate_id)
    console.log(this.insurancestatename)
    console.log(this.brokerLicensedStatesAndProvinces[index].expiryDate)
    console.log(this.datePipe.transform(this.brokerLicensedStatesAndProvinces[index].expiryDate, 'yyyy-MM-dd'))
    // console.log(this.datePipe.transform(date,"yyyy-MM-dd")); //output : 2018-02-13

    let Data =
    {
      "provinces_id": this.insurancestate_id || this.brokerLicensedStatesAndProvinces[index].stateId,
      "provinces_name": this.insurancestatename || this.brokerLicensedStatesAndProvinces[index].stateFullDetails.name,
      "expiry_date": this.datePipe.transform(this.brokerLicensedStatesAndProvinces[index].expiryDate, 'yyyy-MM-dd') || '',
      "reminder_email": parseInt(licenseData.reminderEmail),
      "license_num": licenseData.licenseNumber,
      "license_coverage": licenseData.licenseCoverage
    }


    console.log(Data)
    this.http
      .put(environment.apiUrl + saveAdvisorlicense, Data, {
        headers: {
          Authorization: 'Bearer ' + accessToken,
          'Content-Type': 'application/json',
        },
      })
      .subscribe(
        (response: any) => {
          if (response['status'] == 200 || response['statusCode'] == 200) {
            this.isEditable = true;
            this.enableEditIndex = null
            this.insurancestate_id = null
            this.insurancestatename = null
            this.http.get(environment.apiUrl + '/api/ap/global/set-adminAdvisors').subscribe((newResponse) => {
              this.http.post(environment.reportApiUrl + '/websocket/advisor/notification-to-others', {
                "message": "Advisors information has been updated. Please refresh screen."
              }, {
                headers: {
                  Authorization: 'Bearer ' + accessToken,
                  'Content-Type': 'application/json',
                }
              }).subscribe((res) => {
                console.log({ res })
              })
            })
            this.getBrokerDetails()
            // this.getServiceWorkerDetails()
          } else {
            Swal.fire({ title: 'Error', text: response.message })
          }
        },
        (error) => {
          if (
            error.status == 400 ||
            error.status == 401 ||
            error.status == 402 ||
            error.status == 403
          ) {
            Swal.fire({
              title: 'Error',
              text: error.error.error.message,
              showDenyButton: false,
              showCancelButton: false,
              confirmButtonText: 'Ok',
            }).then((result) => {
              /* Read more about isConfirmed, isDenied below */
              if (result.isConfirmed) {
                sessionStorage.clear();
                this.router.navigate(['/login']);
              }
              else {
                sessionStorage.clear();
                this.router.navigate(['/login']);
              }
            });
          } else {
            // Swal.fire(error.error.error.message)
            Swal.fire({ title: 'Error', text: error.error.error.message });
          }
          // this.toastrService.error("Invalid Credentials", 'Error!');
        }
      );

  }
  checkbrokertype(brokerType) {
    this.brokerTypeName = brokerType;
    console.log(brokerType);
    if (brokerType == 'BROKERAGE') {
      this.showBusinessnumber = true;
      this.broker['businessnumber'].setValidators([Validators.required]);

      this.broker['businessnumber'].updateValueAndValidity();

      // this.stc_generation = 'false';
    } else {
      this.showBusinessnumber = false;

      // this.stc_generation = 'true';

      this.broker['businessnumber'].clearValidators();
      this.broker['businessnumber'].reset();
      this.broker['businessnumber'].updateValueAndValidity();
    }
  }
  phoneFormatForGroupCont(form: FormGroup, id: any) {
    const inputValue = form.get(id).value;
    //this.adminform.controls
    form.get(id).
      setValue(this.phoneNoFormat.transform(inputValue), { emitEvent: false });
  }
  phoneFormat(id: any) {
    const inputValue = this.brokerregform.get(id).value;

    this.brokerregform
      .get(id)
      .setValue(this.phoneNoFormat.transform(inputValue), { emitEvent: false });
  }
  phoneFormatShared(id: any) {
    const inputValue = this.brokerSharedregform.get(id).value;

    this.brokerSharedregform
      .get(id)
      .setValue(this.phoneNoFormat.transform(inputValue), { emitEvent: false });
  }
  phoneFormatDynamic(id: any, form: any) {
    const inputValue = this.grpcontact[id].value;

    this.grpcontact[id].setValue(this.phoneNoFormat.transform(inputValue), {
      emitEvent: false,
    });
  }
  public getprovinceshortName(event: any) {

    this.configprovinceres.forEach((element: any) => {

      // console.log(element.shortName)
      // console.log(event)
      if (element.shortName == event) {

        this.shortNameValue = element.shortName
      }
    });
  }
  editLicenseSubmit() {

    if (this.licenseform.invalid) {
      console.log(this.licenseform);
      return;
    }

    this.getprovinceshortName(this.licenseform.value.state)

    var accessToken = sessionStorage.getItem('accessToken');
    var saveAdvisorlicense = '/api/ap/broker/' + this.brokerlicensedetails.brokerId + '/license/' + this.brokerlicensedetails.id + '';



    let Data =
    {
      "provinces_id": this.insurancestate_id || this.brokerlicensedetails.stateId,
      "provinces_name": this.insurancestatename || this.brokerlicensedetails.stateFullDetails.name,
      "expiry_date": moment(this.licenseform.value.expiryDate, "MM-DD-YYYY").format("MM-DD-YYYY"),
      "reminder_email": parseInt(this.licenseform.value.remainder_days),
      "license_num": this.licenseform.value.licenseNumber,
      "license_coverage": this.licenseform.value.licenseCoverage,
      "provinceshortName": this.shortNameValue
    }


    console.log(Data)
    this.http
      .put(environment.apiUrl + saveAdvisorlicense, Data, {
        headers: {
          Authorization: 'Bearer ' + accessToken,
          'Content-Type': 'application/json',
        },
      })
      .subscribe(
        (response: any) => {
          if (response['status'] == 200 || response['statusCode'] == 200) {
            this.isEditable = true;
            this.enableEditIndex = null
            this.insurancestate_id = ''
            this.insurancestatename = ''
            this.http.get(environment.apiUrl + '/api/ap/global/set-adminAdvisors').subscribe((newResponse) => {
              this.http.post(environment.reportApiUrl + '/websocket/advisor/notification-to-others', {
                "message": "Advisors information has been updated. Please refresh screen."
              }, {
                headers: {
                  Authorization: 'Bearer ' + accessToken,
                  'Content-Type': 'application/json',
                }
              }).subscribe((res) => {
                console.log({ res })
              })
            })
            // this.brokerContactInfo =[]
            this.getBrokerDetails()
            // this.getServiceWorkerDetails()
            $('#basicModaledit').modal('hide');
          } else {
            Swal.fire({ title: 'Error', text: response.message })
          }
        },
        (error) => {
          if (
            error.status == 400 ||
            error.status == 401 ||
            error.status == 402 ||
            error.status == 403
          ) {
            Swal.fire({
              title: 'Error',
              text: error.error.error.message,
              showDenyButton: false,
              showCancelButton: false,
              confirmButtonText: 'Ok',
            }).then((result) => {
              /* Read more about isConfirmed, isDenied below */
              if (result.isConfirmed) {
                sessionStorage.clear();
                this.router.navigate(['/login']);
              }
              else {
                sessionStorage.clear();
                this.router.navigate(['/login']);
              }
            });
          } else {
            // Swal.fire(error.error.error.message)
            Swal.fire({ title: 'Error', text: error.error.error.message });
          }
          // this.toastrService.error("Invalid Credentials", 'Error!');
        }
      );

  }
  editbrokerlicenseSharedSubmit() {
    if (this.licenseform.invalid) {
      console.log(this.licenseform);
      return;
    }
    console.log(JSON.stringify(this.licenseform.value, null, 2));
    this.insuranceprovincelist1(this.licenseform.value.state);

    let obj = {
      // provinces_id: this.insurancestate_id || this.brokerlicensedetails.provinces_id,
      // provinces_name: this.insurancestatename || this.brokerlicensedetails.provinces_name,
      // state_fusebill_id: this.fusebillId || this.brokerlicensedetails.state_fusebill_id,
      // expiry_date:
      //   this.datePipe.transform(
      //     this.licenseform.value.expiryDate,
      //     'MMM-dd-yyyy'
      //   ) || '',
      // reminder_email: parseInt(this.licenseform.value.remainder_days),
      // license_num: this.licenseform.value.licenseNumber,
      // license_coverage: this.licenseform.value.licenseCoverage1,
      // provinceshortName: this.shortNameValue

      provinceId:
        this.insurancestate_id || this.brokerlicensedetails.provinces_id,
      provinceName:
        this.insurancestatename || this.brokerlicensedetails.provinces_name,
      provinceStaxbillId:
        this.fusebillId || this.brokerlicensedetails.state_fusebill_id,
      expiryDate:
        this.datePipe.transform(
          this.licenseform.value.expiryDate,
          'MM-dd-yyyy'
        ) || '',
      remainder_days: parseInt(this.licenseform.value.remainder_days),
      licenseNumber: this.licenseform.value.licenseNumber,
      licenseCoverage: this.licenseform.value.licenseCoverage,
      provinceshortName: this.provinceshortName

    };

    console.log({ obj });

    let licenceExist = false;
    for (let index in this.addlicenseformDataShared) {
      if (
        this.addlicenseformDataShared[index].licenseNumber == obj.licenseNumber &&
        index != this.editindex
      ) {
        licenceExist = true;
        break;
      } else {
        licenceExist = false;
      }
    }

    if (licenceExist) {
      Swal.fire({ title: 'Info', text: 'License Number already exist' });
    } else {
      this.addlicenseformDataShared[this.editindex] = obj;

      sessionStorage.setItem(
        'addlicenseformDataShared',
        JSON.stringify(this.addlicenseformDataShared)
      );
      this.addlicenseformDataShared = JSON.parse(
        sessionStorage.getItem('addlicenseformDataShared') || '[]'
      );

      this.licenseform.reset();
      this.addlicenseform = false;
      this.addlicenseformtable = true;
      $('#basicModaleditShared').modal('hide');
      $('#BrokerSharedNewDetails').modal('show');
    }

    // $('#basicModal1').modal('hide');
  }
  deletelicenseShared(license: any, i: number) {
    Swal.fire({
      title: 'Alert',
      text: 'Are you sure you want to delete this License?',
      showDenyButton: false,
      showCancelButton: true,
      confirmButtonText: 'Proceed',
    }).then((result) => {
      /* Read more about isConfirmed, isDenied below */
      if (result.isConfirmed) {
        this.addlicenseformDataShared.splice(i, 1);

        if (this.addlicenseformDataShared.length == 0) {
          this.addlicenseform = true;
          this.addlicenseformtable = false;
        } else {
          this.addlicenseform = false;
          this.addlicenseformtable = true;
        }
        sessionStorage.setItem(
          'addlicenseformDataShared',
          JSON.stringify(this.addlicenseformDataShared)
        );
      }
    });
  }
  editeoinfosumbit() {
    if (this.eoform.invalid) {
      this.eoform.markAllAsTouched();
      console.log(this.eoform);
      return;
    }
    console.log(this.eoform)


    var accessToken = sessionStorage.getItem('accessToken');
    var updateLicenseEO = '/api/ap/broker/' + this.editbrokerEOinfo.brokerId + '/updateLicenceEO';

    let data = {
      "certificateNumber": this.eoform.value.certificateNumber,
      "expiryDate": moment(this.eoform.value.expiryDate, "MM-DD-YYYY").format("MM-DD-YYYY"),
      "insurerName": this.capitalize(this.eoform.value.insurerName),
      "policyNumber": this.eoform.value.policyNumber
    }
    this.http
      .put(environment.apiUrl + updateLicenseEO, data, {
        headers: {
          Authorization: 'Bearer ' + accessToken,
          'Content-Type': 'application/json',
        },
      })
      .subscribe(
        (response: any) => {
          if (response['status'] == 200 || response['statusCode'] == 200) {
            this.getBrokerDetails()
            //this.getServiceWorkerDetails()
            this.http.get(environment.apiUrl + '/api/ap/global/set-adminAdvisors').subscribe((newResponse) => {
              this.http.post(environment.reportApiUrl + '/websocket/advisor/notification-to-others', {
                "message": "Advisors information has been updated. Please refresh screen."
              }, {
                headers: {
                  Authorization: 'Bearer ' + accessToken,
                  'Content-Type': 'application/json',
                }
              }).subscribe((res) => {
                console.log({ res })
              })
            })
            $('#basicModaleditEO').modal('hide');
          } else {
            Swal.fire({ title: 'Error', text: response.message })
          }
        },
        (error) => {
          if (
            error.status == 400 ||
            error.status == 401 ||
            error.status == 402 ||
            error.status == 403
          ) {
            Swal.fire({
              title: 'Error',
              text: error.error.error.message,
              showDenyButton: false,
              showCancelButton: false,
              confirmButtonText: 'Ok',
            }).then((result) => {
              /* Read more about isConfirmed, isDenied below */
              if (result.isConfirmed) {
                sessionStorage.clear();
                this.router.navigate(['/login']);
              }
              else {
                sessionStorage.clear();
                this.router.navigate(['/login']);
              }
            });
          } else {
            // Swal.fire(error.error.error.message)
            Swal.fire({ title: 'Error', text: error.error.error.message });
          }
          // this.toastrService.error("Invalid Credentials", 'Error!');
        }
      );
  }
  editEOSharedSubmit() {
    if (this.eoform.invalid) {
      console.log(this.eoform);
      return;
    }
    console.log(JSON.stringify(this.eoform.value, null, 2));

    this.EOinsurenceInfo = this.eoform.value;

    this.eoform.reset();
    this.showaddEOdetails = true;
    this.addEOform = false;
    $('#basicModaleoeditShared').modal('hide');
    $('#BrokerSharedNewDetails').modal('show');
    // $('#basicModal1').modal('hide');
  }
  deleteEOShared(index: any) {
    Swal.fire({
      title: 'Alert',
      text: 'Are you sure you want to delete this EO?',
      showDenyButton: false,
      showCancelButton: true,
      confirmButtonText: 'Proceed',
    }).then((result) => {
      /* Read more about isConfirmed, isDenied below */
      if (result.isConfirmed) {
        this.EOinsurenceInfo = '';
        this.eoform.reset();

        if (this.EOinsurenceInfo.length == 0) {
          this.addEOform = true;
          this.showaddEOdetails = false;
        } else {
          this.addEOform = false;
          this.showaddEOdetails = true;
        }
      }
    });
  }
  saveEOInfo(broker: any, index: number) {



    var accessToken = sessionStorage.getItem('accessToken');
    var updateLicenseEO = '/api/ap/broker/' + broker.brokerId + '/updateLicenceEO';

    let EOData = this.brokerEOinformation[index]
    let data = {
      "certificateNumber": EOData.certificateNumber,
      "expiryDate": this.datePipe.transform(
        EOData.expiryDate,
        'MM-dd-yyy'
      ) || '',
      "insurerName": this.capitalize(EOData.insurerName),
      "policyNumber": EOData.policyNumber
    }

    console.log(data)

    this.http
      .put(environment.apiUrl + updateLicenseEO, data, {
        headers: {
          Authorization: 'Bearer ' + accessToken,
          'Content-Type': 'application/json',
        },
      })
      .subscribe(
        async (response: any) => {
          if (response['status'] == 200 || response['statusCode'] == 200) {
            this.isEditableEO = true;
            this.enableEditIndexEO = null
            // await postServiceWorkerMessage(WorkerMessageType.Delete, [
            //   environment.apiUrl + updateLicenseEO
            // ]);
            // this.brokerEOinformation = []
            this.getBrokerDetails()
            this.http.get(environment.apiUrl + '/api/ap/global/set-adminAdvisors').subscribe((newResponse) => {
              this.http.post(environment.reportApiUrl + '/websocket/advisor/notification-to-others', {
                "message": "Advisors information has been updated. Please refresh screen."
              }, {
                headers: {
                  Authorization: 'Bearer ' + accessToken,
                  'Content-Type': 'application/json',
                }
              }).subscribe((res) => {
                console.log({ res })
              })
            })
            //this.getServiceWorkerDetails()
          } else {
            Swal.fire({ title: 'Error', text: response.message })
          }
        },
        (error) => {
          if (
            error.status == 400 ||
            error.status == 401 ||
            error.status == 402 ||
            error.status == 403
          ) {
            Swal.fire({
              title: 'Error',
              text: error.error.error.message,
              showDenyButton: false,
              showCancelButton: false,
              confirmButtonText: 'Ok',
            }).then((result) => {
              /* Read more about isConfirmed, isDenied below */
              if (result.isConfirmed) {
                sessionStorage.clear();
                this.router.navigate(['/login']);
              }
              else {
                sessionStorage.clear();
                this.router.navigate(['/login']);
              }
            });
          } else {
            // Swal.fire(error.error.error.message)
            Swal.fire({ title: 'Error', text: error.error.error.message });
          }
          // this.toastrService.error("Invalid Credentials", 'Error!');
        }
      );

  }
  ngAfterViewInit() {
    // this.message = 'all done loading :)'
  }
  editadvisorlicenseDetails(e, i, broker) {
    // this.isEditable =false;
    // this.enableEditIndex = i;
    // console.log(i, e);

    console.log(broker)
    this.brokerlicensedetails = broker
    // this.editindex = i;
    this.editbrokerlicensenumber = broker.licenseNumber;
    this.editbrokerlicensecoverage = broker.licenseCoverage;
    this.editbrokerlicensestate = broker.stateFullDetails.shortName;
    // this.editbrokerlicenseexpirydate = this.datePipe.transform(broker.expiryDate, "MM-dd-yyyy") || "";
    this.editbrokerlicenseexpirydate = broker.expiryDate
    this.editbrokerlicenseexpiryremainder = broker.reminderEmail;
    // this.editbrokerlicenseshortName = broker.provinceshortName

    this.cdr.detectChanges();

  }

  addRow() {
    this.brokersalesCodes.push({
      brokerId: '',
      percentage: '',
    });
  }

  deleteRow(index: number, dynamic: any) {

    // alert(index)

    console.log(this.brokersalesCodes)

    // if (this.brokersalesCodes.length == 1) {
    //   Swal.fire({
    //     title: 'Warning',
    //     text: "Can't delete the row when there is only one row",
    //   });
    //   return false;
    // }

    if (index == 0) {
      Swal.fire({
        title: 'Warning',
        text: "Can't delete the Existing Broker",
      });
      return false;
    }
    else {
      this.brokersalesCodes.splice(index, 1);
      const totalValue = this.brokersalesCodes.reduce((sum, item) => sum + +item.commission, 0);
      this.totalValue = totalValue
      if (this.brokersalesCodes.length == +this.broker['brokerCount'].value + 1) {
        this.showSharedBrokerList = false
        this.showsharedformData = true
        // this.brokerregform.get('brokerCount').setValue(this.brokersalesCodes.length - 1);
      }
      else {
        if (this.brokersalesCodes.length == 0) {
          this.showsalestrackinCodeAuto = false
          this.showaddprofileData = false

        }
        this.showSharedBrokerList = true
        // this.showsharedformData = false
        if (this.totalValue == 100) {
          this.showsharedformData = true
        } else {
          this.showsharedformData = false
        }
        // this.brokerregform.get('brokerCount').setValue(this.brokersalesCodes.length - 1);
      }
      this.labeldata = []
      this.realdata = []
      console.log(this.brokersalesCodes)
      for (let i = 0; i < this.brokersalesCodes.length; i++) {
        this.labeldata.push(this.brokersalesCodes[i].brokerName);
        this.realdata.push(this.brokersalesCodes[i].commission);
        // this.colordata.push(this.chartInfo[i].colorcode);
      }
      this.createChart(this.labeldata, this.realdata);

      setTimeout(() => {
        this.showSelectdAdvsiors = [];
        this.allBrokersUnique.map((data) => {
          console.log(data)
          console.log(this.brokersalesCodes)

          this.brokersalesCodes.forEach((product) => {

            if (data.id == product.brokerId) {
              this.showSelectdAdvsiors.push(data)

            }


          })

          console.log("showmulti", this.showSelectdAdvsiors)

        });

        this.broker['ParentbrokerName'].setValue(this.showSelectdAdvsiors);
        console.log(this.broker['ParentbrokerName'])

      }, 1000);
    }
    this.brokerregform.get('brokerCount').setValue(this.brokersalesCodes.length - 1);


  }
  hidegrpadmindetailsShared1() {
    this.adminform.reset();
    this.allplansArray = [];
    this.ShowOthers = false;
    $('#BrokerSharedNewDetails').hide();

  }
  editadvisorlicenseDetailsShared(e, i, broker) {
    console.log(broker);

    this.brokerlicensedetails = broker;
    this.editindex = i;
    this.editbrokerlicensenumber = broker.licenseNumber;
    this.editbrokerlicensecoverage = broker.licenseCoverage;
    this.editbrokerlicensestate = broker.provinceshortName;
    this.editbrokerlicenseexpirydate =
      this.datePipe.transform(broker.expiryDate, 'MM-dd-yyyy') || '';
    this.editbrokerlicenseexpiryremainder = broker.remainder_days;
    this.editbrokerlicenseshortName = broker.provinceshortName;
    $("#BrokerSharedNewDetails").hide()
    // this.isEditable =false;
    // this.enableEditIndex = i;
    // console.log(i, e);
    // this.addlicenseformData = JSON.parse(sessionStorage.getItem('addlicenseformData'))
  }
  addnewlicenseShared() {
    this.licenseform.reset();
    this.licenseform.get('licenseCoverage').setValue('');
    this.licenseform.get('licenseCoverage').updateValueAndValidity();
    this.licenseform.get('state').setValue('');
    this.licenseform.get('state').updateValueAndValidity();
    $('#BrokerSharedNewDetails').hide()
  }
  editEOShared() {
    this.EOinsurenceInfo.expiryDate = moment(
      this.EOinsurenceInfo.expiryDate
    ).format('MM-DD-YYYY');

    console.log(this.EOinsurenceInfo);
    this.eoform.patchValue(this.EOinsurenceInfo);

    $('#BrokerSharedNewDetails').hide();
  }
  hideaddlicenseformShared() {
    this.licenseform.reset();
    $('#basicModaleditShared').modal('hide');
    $('#basicModal1Shared').modal('hide');
    $('#BrokerSharedNewDetails').modal('show');
  }
  closesharedmodel() {
    this.showPlans = true;
    const preservedValues = {
      brokerCount: this.brokerregform.get('brokerCount')?.value,

      brokerShare: this.brokerregform.get('brokerShare')?.value,
      brokerStatus: this.brokerregform.get('brokerStatus')?.value

    };
    this.brokerregform.reset(preservedValues);
    this.adminform.reset();
    this.licenseform.reset();
    this.formCreation.reset();
    this.adminData = []
    this.addlicenseformData = []
    this.EOinsurenceInfo = '';
    this.addadminform = true
    this.showaddadmin = false
    this.addlicenseform = true
    this.addlicenseformtable = false
    this.addEOform = true
    this.showaddEOdetails = false
    $('#BrokerSharedNewDetails').hide()
    window.location.reload()

  }
  createChart(labeldata: any, realdata: any) {

    console.log(labeldata)
    console.log(realdata)
    if (this.chart) {
      this.chart.clear();
      this.chart.destroy();
    }
    this.chart = new Chart("MyChart", {
      type: 'pie', //this denotes tha type of chart

      data: {
        labels: labeldata,
        datasets: [
          {
            label: 'Commission',
            data: realdata,
            backgroundColor: [
              'blue',
              'pink',
              'green',
              'yellow',
              'orange',
              'red',
            ],
            hoverOffset: 4,
          },
        ],
      },
      options: {
        aspectRatio: 2.5
      }

    });

  }

  editSaleslTrackingCode(e, i, broker) {
    console.log(broker)
    this.salesTrackingCode = broker.salesTrackingCode.code
    broker.salesTrackingCode.salesTrackingCodeShares.forEach((b, i) => {
      this.brokersalesCodes.push({
        brokerId: b.brokerId,
        percentage: b.percentage,
      })
    })


  }



  saveEditSalesTrackingCodes() {

    var accessToken = sessionStorage.getItem('accessToken');
    var saveAdvisorlicense = '/api/ap/broker/salesTrackingCode/commisions';
    const convert = this.brokersalesCodes.map((b) => {
      return {
        brokerId: Number(b.brokerId),
        percentage: Number(b.percentage)
      }
    })
    console.log({ convert })
    const obj = {
      code: this.salesTrackingCode,
      salesTrackingCodeShares: [...convert]
    }
    this.http
      .put(environment.apiUrl + saveAdvisorlicense, obj, {
        headers: {
          Authorization: 'Bearer ' + accessToken,
          'Content-Type': 'application/json',
        },
      })
      .subscribe(
        (response: any) => {
          if (response['status'] == 200 || response['statusCode'] == 200) {
            Swal.fire({ title: 'Info', text: response?.message })

            $('#salesTrackingEdit').modal('hide');
            this.brokersalesCodes = []
            this.salesTrackingCode = ''
            this.getBrokerDetails()
            // this.getServiceWorkerDetails()
          } else {
            Swal.fire({ title: 'Error', text: response?.message })
          }
        },
        (error) => {
          console.log(error.error.message)
          if (error.error.status == 422) {
            console.log(error.error.message)

            Swal.fire({
              title: 'Error', text: error.error.message, showDenyButton: false,
              showCancelButton: false,
              confirmButtonText: 'Ok',
            })
            // Swal.fire({ title: 'Error', text: error.error.error.message })
            // Swal.fire({ title: 'Error', text: "ok" })
          }
          else if (
            error.status == 400 ||
            error.status == 401 ||
            error.status == 402 ||
            error.status == 403
          ) {
            Swal.fire({
              title: 'Error',
              text: error.error.error.message,
              showDenyButton: false,
              showCancelButton: false,
              confirmButtonText: 'Ok',
            }).then((result) => {
              /* Read more about isConfirmed, isDenied below */
              if (result.isConfirmed) {
                sessionStorage.clear();
                this.router.navigate(['/login']);
              }
              else {
                sessionStorage.clear();
                this.router.navigate(['/login']);
              }
            });
          } else {
            Swal.fire({ title: 'Error', text: error.error.error.message });
          }
        }
      );



  }
  sharedBrokerType(event: any) {
    console.log(event.target.value)
    console.log(typeof event.target.value)
    if (event.target.value == "true") {

      this.showSharedAdvisorData = false;
      // this.noofbrokerscount =true
    }
    else {
      this.showSharedAdvisorData = true;
      // this.noofbrokerscount =false
    }

  }
  closeEditSalesTrackingCodes() {
    console.log(this.brokersalesCodes)
    this.brokersalesCodes = []
  }

  editadvisorEODetails(e, i, broker) {

    console.log(broker)

    this.editindex = i;

    this.editbrokerEOinfo = broker
    this.editEOinsurerName = broker.insurerName;
    this.editEOpolicy = broker.policyNumber;
    this.editEOcertificate = broker.certificateNumber;
    this.editEOExpiryDate = broker.expiryDate;
  }

  public isParentsGreaterThanOne(groups: any): boolean {
    // console.log(Object.keys(groups), Object.keys(groups).length > 1)
    return groups && Object.keys(groups).length > 1;
  }

  public showPricing = false;


  getStatus(published, restricted) {
    let data = -1;
    if (published) {
      if (restricted) {
        data = 2
      }
      else {
        data = 1
      }

    }
    else {
      data = 0
    }
    return data
  }

  public colors = { 0: "#FF3131", 1: "#37FBB3", 2: "black" }
  public text = { 0: "Unpublished", 1: "Published", 2: "Published but Restricted" }

  getColorForPlans(published, restricted) {

    const pubStatus = { 0: false, 1: true }
    // console.log(pubStatus[published], restricted)
    let data = this.getStatus(pubStatus[published], restricted)
    return this.colors[data]
  }

  getTextForTooltip(published, restricted) {
    const pubStatus = { 0: false, 1: true }
    let data = this.getStatus(pubStatus[published], restricted)
    return this.text[data]
  }

  getColorForPlans1(published, restricted) {

    let data: any = this.getStatus(published, restricted)
    const color = this.colors[data];
    return color;
  }

  getTextForTooltip1(published, restricted) {
    let data: any = this.getStatus(published, restricted)
    const text = this.text[data]
    return text
  }


  initializePlansArray(pArray: any, checked: boolean, disabled: boolean, type?: string,) {
    this.allplansArray = []

    pArray.forEach(product => {
      let obj = {
        packageCheckbox: type === 'EXECUTIVE' && product.name === 'Private Health' ? true : checked,
        packageId: product.id,
        packageName: product.name,
        disabled: disabled,

      };


      Object.keys(product.parents).forEach((plan: any) => {
        product.parents[plan].forEach((p) => {

          obj[p.name] = {
            planCheckbox: type === 'EXECUTIVE' && product.name === 'Private Health' ? true : checked,
            planId: p.id,
            parentId: p.parentId,
            planName: p.name,
            disabled: disabled,

          };
          obj[plan] = {
            checked: checked,
            disabled: disabled,
            isParent: true,
            id: p.parentId || ""
          }
        }
        )

      });


      this.allplansArray[product.name] = obj
    });
    console.log({ plansArray: this.allplansArray })
  }

  changePackageCheckedValues(productName: any, productId: any, bool: boolean) {
    this.allplansArray[productName]['packageCheckbox'] = bool;
    Object.keys(this.allplansArray[productName]).forEach((p, id) => {
      if (typeof this.allplansArray[productName][p] === 'object') {
        this.allplansArray[productName][p]['planCheckbox'] = bool;
      }
    })

    Object.keys(this.allplansArray[productName]).forEach((p, id) => {
      if (typeof this.allplansArray[productName][p] === 'object' && this.allplansArray[productName][p].isParent) {
        this.allplansArray[productName][p].checked = bool;
      }
    })
    console.log({ plansArray: this.allplansArray })

  }


  checkForClassic() {
    let flag = 0

    Object.keys(this.allplansArray).forEach((pack: any) => {
      if (this.allplansArray[pack].packageId == 1) {
        Object.keys(this.allplansArray[pack]).forEach((p) => {
          if (typeof this.allplansArray[pack][p] === 'object' && p.includes("Classic") && this.allplansArray[pack][p]['parentId'] && this.allplansArray[pack][p]['planCheckbox'] === true) {
            flag = flag + 1
          }
        });
      }
    });

    if (flag >= 1) {
      this.showPricing = true;
    }
    else {
      this.showPricing = false;
    }
  }

  toggleAllPlans(productName: any, productId: any, event: any) {
    console.log(productName, productId, event.target.checked)

    if (event.target.checked) {
      this.plansError = false;
      this.changePackageCheckedValues(productName, productId, true)

    }
    else {
      this.changePackageCheckedValues(productName, productId, false)

    }

    console.log({ plansArray: this.allplansArray })

    this.checkForClassic()


  }

  checkForAllPlansChecked(productName, planKey: any, parentId) {

    let planFlag = Object.keys(this.allplansArray[productName]).some((p) => {
      return (typeof this.allplansArray[productName][p] === 'object' && this.allplansArray[productName][p]['parentId'] === parentId && this.allplansArray[productName][p]['planCheckbox'] === false)
    });
    this.allplansArray[productName][planKey].checked = !planFlag;


    let flag = Object.keys(this.allplansArray[productName]).some((p) => {
      return (typeof this.allplansArray[productName][p] === 'object' && this.allplansArray[productName][p]['parentId'] != 'null' && this.allplansArray[productName][p]['planCheckbox'] === false)
    });


    this.allplansArray[productName].packageCheckbox = !flag;


    console.log({ plansAyyay: this.allplansArray })
  }

  changePlanCheckedValues(productName: any, planKey: any, parentId: any) {
    this.allplansArray[productName].packageCheckbox = false;
    this.allplansArray[productName][planKey].checked = false;
    this.checkForAllPlansChecked(productName, planKey, parentId)
    this.checkForClassic()

    console.log(this.allplansArray)

  }

  planCheckbox(productName: any, planKey: any, parentId: any, planName: any, planId: any, event: any) {
    let disabled = true
    if (event.target.checked) {

      console.log(planName)
      this.plansError = false
      this.allplansArray[productName][planName].planCheckbox = true;
      this.changePlanCheckedValues(productName, planKey, parentId)
      if (planName.includes("La Vie")) {
          const dom: HTMLElement = this.elementRef.nativeElement;
          // const plan: any = dom.querySelector(`#plancheck792`)
        const plan: any = dom.querySelector("#planCheckbox18");
          setTimeout(() => {
            plan.click()
            this.toastrService.success("La Vie plan selection automatically includes Complete Executive Care plan", "");
          }, 1000);




      }
    }
    else {
      this.allplansArray[productName][planName].planCheckbox = false;
      this.changePlanCheckedValues(productName, planKey, parentId)
    }
    this.checkForAllPlansChecked(productName, planKey, parentId)
    this.checkForClassic()
  }

  planKeyCheckbox(productName: any, planKey: any, parentId: any, event: any) {
    if (event.target.checked) {
      this.plansError = false

      this.allplansArray[productName][planKey].checked = true
      Object.keys(this.allplansArray[productName]).forEach((p, id) => {
        if (typeof this.allplansArray[productName][p] === 'object' && typeof this.allplansArray[productName][p].hasOwnProperty('parentId')) {
          if (this.allplansArray[productName][p]['parentId'] == parentId) {
            this.allplansArray[productName][p]['planCheckbox'] = true
            console.log(this.allplansArray[productName][p]['parentId'] == parentId, this.allplansArray[productName][p]['planCheckbox'],)

          }
        }
      })
    }
    else {
      this.allplansArray[productName][planKey].checked = false
      Object.keys(this.allplansArray[productName]).forEach((p, id) => {
        if (typeof this.allplansArray[productName][p] === 'object' && typeof this.allplansArray[productName][p].hasOwnProperty('parentId')) {
          if (this.allplansArray[productName][p]['parentId'] == parentId) {
            this.allplansArray[productName][p]['planCheckbox'] = false
          }
        }
      })
    }
    console.log({ "plansArray": this.allplansArray })
    this.checkForAllPlansChecked(productName, planKey, parentId)
    this.checkForClassic()
  }


  initializeCustomizePlansArray(formLevels: any) {
    Object.keys(this.allplansArray).forEach((product) => {
      // console.log({ product })
      Object.keys(this.allplansArray[product]).forEach((plan) => {
        // console.log(this.allplansArray[product][plan])

        if (typeof this.allplansArray[product][plan] == "object" && this.allplansArray[product][plan]['planId'] != null) {
          console.log(product, plan, this.allplansArray[product], this.allplansArray[product][plan])

          this.allplansArray[product][plan]['planCheckbox'] = formLevels.includes(this.allplansArray[product][plan]['planId'])

        }

      })

    })

    Object.keys(this.allplansArray).forEach((product) => {
      Object.keys(this.allplansArray[product]).forEach((plan) => {

        if (typeof this.allplansArray[product][plan] == "object" && this.allplansArray[product][plan]['isParent'] == true) {
          this.changePlanCheckedValues(product, plan, this.allplansArray[product][plan].id)
        }
      })

    })
    this.checkForClassic()
    console.log({ plansArrayCustomise: this.allplansArray })
  }


  editadvisorformDetails(e, i, form) {
    // this.isEditableForm =false;
    // this.enableEditIndexForm = i;
    // console.log(i, e);
    // this.addformDetails = JSON.parse(sessionStorage.getItem('addformDetails'))

    // alert(form.matchedProfile.name)

    console.log(form)
    this.editFormDetails = form

    console.log(form, form.filterProductType)
    this.editindex = i;
    this.editFormType = form.formType;
    this.editFormProfile = form.matchedProfile.originalBrokerId;
    this.editFormName = form.name;
    this.editFormDescription = form.description;
    this.editFormlink = "";
    this.editFormlogo = form.logo || "/assets/img/logo.png";
    this.editFormDisclousreAggrement = "";
    this.planLevels = form.planLevels
    this.editFormPricingOptions = form.filterProductType;





    if (this.editFormType === 'REGULAR') {
      this.initializePlansArray(this.productsArray, true, false, 'REGULAR')
    }
    if (this.editFormType === 'EXECUTIVE') {
      this.initializePlansArray(this.productsArray, false, false, 'EXECUTIVE')
    }
    if (this.editFormType === 'CUSTOM') {
      this.initializePlansArray(this.productsArray, false, false, 'CUSTOM')

    }
    console.log(form)
    console.log(form.signupFormPlanLevels)
    if (form.signupFormPlanLevels) {

      if (form.formType == 'CUSTOM') {

        this.customForm = true

        const plansSelected = form.signupFormPlanLevels.map((plan) => (
          plan.planLevelId
        ))
        this.selectedPlanLevels = plansSelected;
        console.log({ plansSelected })

        this.selectedItems = form.planLevels
        this.initializeCustomizePlansArray(plansSelected)

        // this.form['formplanLevels'].setValidators([Validators.required]);;

        // this.form['formplanLevels'].updateValueAndValidity();
      }
      else {
        this.customForm = false
        // this.form['formplanLevels'].clearValidators();

        // this.form['formplanLevels'].updateValueAndValidity();
      }


    }
    else {

      this.customForm = false
      // this.form['formplanLevels'].clearValidators();

      // this.form['formplanLevels'].updateValueAndValidity();
    }
    this.showPlans = true
    this.showaddplans = false;
    this.showeditplans = true;
    $('#basicModalFormedit').modal('show');
  }

  deletelicense(license: any, i: number) {

    Swal.fire({
      title: 'Alert',
      text: 'Are you sure you want to delete this License?',
      showDenyButton: false,
      showCancelButton: true,
      confirmButtonText: 'Proceed',
    }).then((result) => {
      /* Read more about isConfirmed, isDenied below */
      if (result.isConfirmed) {

        var accessToken = sessionStorage.getItem('accessToken');
        var deleteBrokerlicens = '/api/ap/broker/' + license.brokerId + '/license/' + license.id + '';

        this.http
          .delete(environment.apiUrl + deleteBrokerlicens, {
            headers: {
              Authorization: 'Bearer ' + accessToken,
              'Content-Type': 'application/json',
            },
          })
          .subscribe(
            (response: any) => {
              if (response['status'] == 200 || response['statusCode'] == 200) {
                this.http.get(environment.apiUrl + '/api/ap/global/set-adminAdvisors').subscribe((newResponse) => {
                  this.http.post(environment.reportApiUrl + '/websocket/advisor/notification-to-others', {
                    "message": "Advisors information has been updated. Please refresh screen."
                  }, {
                    headers: {
                      Authorization: 'Bearer ' + accessToken,
                      'Content-Type': 'application/json',
                    }
                  }).subscribe((res) => {
                    console.log({ res })
                  })
                })
                this.getBrokerDetails()
                //this.getServiceWorkerDetails()
              } else {
                Swal.fire({ title: 'Error', text: response.message })
              }
            },
            (error) => {
              if (
                error.status == 400 ||
                error.status == 401 ||
                error.status == 402 ||
                error.status == 403
              ) {
                Swal.fire({
                  title: 'Error',
                  text: error.error.error.message,
                  showDenyButton: false,
                  showCancelButton: false,
                  confirmButtonText: 'Ok',
                }).then((result) => {
                  /* Read more about isConfirmed, isDenied below */
                  if (result.isConfirmed) {
                    sessionStorage.clear();
                    this.router.navigate(['/login']);
                  }
                  else {
                    sessionStorage.clear();
                    this.router.navigate(['/login']);
                  }
                });
              } else {
                // Swal.fire(error.error.error.message)
                Swal.fire({ title: 'Error', text: error.error.error.message });
              }
              // this.toastrService.error("Invalid Credentials", 'Error!');
            }
          );

      }
    })


  }

  deleteEO(license: any, index: number) {

    Swal.fire({
      title: 'Alert',
      text: 'Are you sure you want to delete this E&O?',
      showDenyButton: false,
      showCancelButton: true,
      confirmButtonText: 'Proceed',
    }).then((result) => {
      /* Read more about isConfirmed, isDenied below */
      if (result.isConfirmed) {


        var accessToken = sessionStorage.getItem('accessToken');
        var deleteBrokerlicenseEO = '/api/ap/broker/' + license.brokerId + '/EOI';

        this.http
          .delete(environment.apiUrl + deleteBrokerlicenseEO, {
            headers: {
              Authorization: 'Bearer ' + accessToken,
              'Content-Type': 'application/json',
            },
          })
          .subscribe(
            (response: any) => {
              if (response['status'] == 200 || response['statusCode'] == 200) {
                this.http.get(environment.apiUrl + '/api/ap/global/set-adminAdvisors').subscribe((newResponse) => {
                  this.http.post(environment.reportApiUrl + '/websocket/advisor/notification-to-others', {
                    "message": "Advisors information has been updated. Please refresh screen."
                  }, {
                    headers: {
                      Authorization: 'Bearer ' + accessToken,
                      'Content-Type': 'application/json',
                    }
                  }).subscribe((res) => {
                    console.log({ res })
                  })
                })
                this.getBrokerDetails()
                //  this.getServiceWorkerDetails()
                this.eoform.reset()
              } else {
                Swal.fire({ title: 'Error', text: response.message })
              }
            },
            (error) => {
              if (
                error.status == 400 ||
                error.status == 401 ||
                error.status == 402 ||
                error.status == 403
              ) {
                Swal.fire({
                  title: 'Error',
                  text: error.error.error.message,
                  showDenyButton: false,
                  showCancelButton: false,
                  confirmButtonText: 'Ok',
                }).then((result) => {
                  /* Read more about isConfirmed, isDenied below */
                  if (result.isConfirmed) {
                    sessionStorage.clear();
                    this.router.navigate(['/login']);
                  }
                  else {
                    sessionStorage.clear();
                    this.router.navigate(['/login']);
                  }
                });
              } else {
                // Swal.fire(error.error.error.message)
                Swal.fire({ title: 'Error', text: error.error.error.message });
              }
              // this.toastrService.error("Invalid Credentials", 'Error!');
            }
          );

      }
    })


  }

  deleteForm(from: any, i: number) {


    // console.log(from)
    Swal.fire({
      title: 'Alert',
      text: 'Are you sure you want to delete this form?',
      showDenyButton: false,
      showCancelButton: true,
      confirmButtonText: 'Proceed',
    }).then((result) => {
      /* Read more about isConfirmed, isDenied below */
      if (result.isConfirmed) {
        // this.brokerFormData.splice(i, 1);
        var accessToken = sessionStorage.getItem('accessToken');
        var deleteBrokerForm = '/api/ap/broker/form/' + from.id + '';

        this.http
          .delete(environment.apiUrl + deleteBrokerForm, {
            headers: {
              Authorization: 'Bearer ' + accessToken,
              'Content-Type': 'application/json',
            },
          })
          .subscribe(
            (response: any) => {
              if (response['status'] == 200 || response['statusCode'] == 200) {

                this.getBrokerDetails()
                //this.getServiceWorkerDetails()
                this.http.get(environment.apiUrl + '/api/ap/global/set-adminAdvisors').subscribe((newResponse) => {
                  this.http.post(environment.reportApiUrl + '/websocket/advisor/notification-to-others', {
                    "message": "Advisors information has been updated. Please refresh screen."
                  }, {
                    headers: {
                      Authorization: 'Bearer ' + accessToken,
                      'Content-Type': 'application/json',
                    }
                  }).subscribe((res) => {
                    console.log({ res })
                  })
                })

              } else {
                Swal.fire({ title: 'Error', text: response.message })
              }
            },
            (error) => {
              if (
                error.status == 400 ||
                error.status == 401 ||
                error.status == 402 ||
                error.status == 403
              ) {
                Swal.fire({
                  title: 'Error',
                  text: error.error.error.message,
                  showDenyButton: false,
                  showCancelButton: false,
                  confirmButtonText: 'Ok',
                }).then((result) => {
                  /* Read more about isConfirmed, isDenied below */
                  if (result.isConfirmed) {
                    sessionStorage.clear();
                    this.router.navigate(['/login']);
                  }
                  else {
                    sessionStorage.clear();
                    this.router.navigate(['/login']);
                  }
                });
              } else {
                // Swal.fire(error.error.error.message)
                Swal.fire({ title: 'Error', text: error.error.error.message });
              }
              // this.toastrService.error("Invalid Credentials", 'Error!');
            }
          );
        if (this.brokerFormData.length == 0) {
          this.initializePlansArray(this.productsArray, false, false, 'CUSTOM')
          this.showaddform = true;
          this.showFormsDetails = false;
          this.showPlans = true;
        }
        else {
          this.showaddform = false;
          this.showFormsDetails = true;
          this.showPlans = false;
        }
      }
    })
  }
  saveForm(form: any, index: number) {

    console.log(form)
    console.log(index)


    let obj = {
      formType: form.formType,
      name: form.name,
      description: form.description,
      link: "",
      planLevels: form.planLevels || [],
      logo: form.logo || "",
      // formDisclosureAgreement: this.licenseform.value.formdisclosureAgreement || "",
    };


    this.addformDetails[index] = obj;
    // this.addlicenseformData.push(obj);
    this.isEditableForm = true;
    this.enableEditIndexForm = null

    console.log(this.addformDetails)
    sessionStorage.setItem(
      'addformDetails',
      JSON.stringify(this.addformDetails)
    );
  }

  cancellicneseEdit(e, i) {
    this.isEditable = true;
    this.enableEditIndex = null;
    this.getBrokerDetails()
    //this.getServiceWorkerDetails()

  }
  cancelEOEdit(e, i) {
    this.isEditableEO = true;
    this.enableEditIndexEO = null;
    this.getBrokerDetails()
    //this.getServiceWorkerDetails()

  }
  cancelFormEdit(e, i) {
    this.isEditableForm = true;
    this.enableEditIndexForm = null;

    console.log(this.globalbrokerFormData)
    this.brokerFormData = this.globalbrokerFormData
    console.log(this.brokerFormData)
  }

  // brokertype(brokerType){

  //   if(brokerType=="Brokerage"){
  //       this.showBusinessnumber =true
  //   }
  //   else{
  //     this.showBusinessnumber =false
  //   }

  // }
  scrollTop() {
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth',
    });
  }
  copy(text: string) {


    this._clipboardService.copy(text)
  }
  copylink() {
    this.toastrService.success("link copied to Clipboard");
  }
  brokertype(brokerType) {
    // alert(brokerType)

    if (brokerType == "BROKERAGE") {
      this.showBusinessnumber = true

      this.broker['businessnumber'].setValidators([Validators.required]);

      this.broker['businessnumber'].updateValueAndValidity();

      // this.stc_generation = "false"
    }
    else {
      this.showBusinessnumber = false

      // this.stc_generation = "true"

      this.broker['businessnumber'].clearValidators();

      this.broker['businessnumber'].updateValueAndValidity();
    }

  }
  numberOnly(event: any): boolean {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }
  hidegrpadmindetailsSharedEO() {
    // this.adminform.reset();
    // this.allplansArray = [];
    // this.ShowOthers = false;
    $('#basicModaleoeditShared').modal('hide');
    $('#BrokerSharedNewDetails').modal('show');

  }
  hidegrpadmindetailsShared() {
    this.adminform.reset();
    this.allplansArray = [];
    this.ShowOthers = false;
    $('#basicModaleditgroupcontactShared').modal('hide');
    $('#basicModaladdgrpcontactShared').modal('hide');

    $('#BrokerSharedNewDetails').modal('show');

  }



  addnewlicense() {
    this.licenseform.reset();
    this.licenseform.get('licenseCoverage').setValue('');
    this.licenseform.get('licenseCoverage').updateValueAndValidity();
    this.licenseform.get('state').setValue('');
    this.licenseform.get('state').updateValueAndValidity();
  }
  addlicense() {
    if (this.licenseform.invalid) {
      console.log(this.licenseform.value);
      return;
    }
    console.log(JSON.stringify(this.licenseform.value, null, 2));

    let obj = {
      provinces_id: this.insurancestate_id,
      provinces_name: this.insurancestatename,
      expiry_date: moment(this.licenseform.value.expiryDate, "MM-DD-YYYY").format("MM-DD-YYYY"),
      reminder_email: parseInt(this.licenseform.value.remainder_days),
      license_num: this.licenseform.value.licenseNumber,
      license_coverage: this.licenseform.value.licenseCoverage,
    };

    var accessToken = sessionStorage.getItem('accessToken');
    var addlcienseinfo = '/api/ap/broker/' + this.brokerid + '/brokerStateLicense';

    this.http
      .post(environment.apiUrl + addlcienseinfo, obj, {
        headers: {
          Authorization: 'Bearer ' + accessToken,
          'Content-Type': 'application/json',
        },
      })
      .subscribe(
        (response: any) => {
          if (response['status'] == 200 || response['statusCode'] == 200) {

            this.getBrokerDetails()

            this.http.get(environment.apiUrl + '/api/ap/global/set-adminAdvisors').subscribe((newResponse) => {
              this.http.post(environment.reportApiUrl + '/websocket/advisor/notification-to-others', {
                "message": "Advisors information has been updated. Please refresh screen."
              }, {
                headers: {
                  Authorization: 'Bearer ' + accessToken,
                  'Content-Type': 'application/json',
                }
              }).subscribe((res) => {
                console.log({ res })
              })
            })

            // this.getServiceWorkerDetails()
            this.addlicenseformData.push(obj);
            this.licenseform.reset();
            $('#basicModal1').modal('hide');
          } else {
            Swal.fire({ title: 'Error', text: response.message })
          }
        },
        (error) => {
          if (
            error.status == 400 ||
            error.status == 401 ||
            error.status == 402 ||
            error.status == 403
          ) {
            Swal.fire({
              title: 'Error',
              text: error.error.error.message,
              showDenyButton: false,
              showCancelButton: false,
              confirmButtonText: 'Ok',
            }).then((result) => {
              /* Read more about isConfirmed, isDenied below */
              if (result.isConfirmed) {
                sessionStorage.clear();
                this.router.navigate(['/login']);
              }
              else {
                sessionStorage.clear();
                this.router.navigate(['/login']);
              }
            });
          } else {
            // Swal.fire(error.error.error.message)
            Swal.fire({ title: 'Error', text: error.error.error.message });
          }
          // this.toastrService.error("Invalid Credentials", 'Error!');
        }
      );



  }
  addlicenseShared() {
    if (this.licenseform.invalid) {
      console.log(this.licenseform.value);
      return;
    }
    console.log(JSON.stringify(this.licenseform.value, null, 2));
    // alert(this.insurancestatename)
    let obj = {
      // provinces_id: this.insurancestate_id,
      // provinces_name: this.insurancestatename,
      // state_fusebill_id: this.fusebillId,
      // expiry_date:
      //   this.datePipe.transform(
      //     this.licenseform.value.expiryDate,
      //     'MMM-dd-yyyy'
      //   ) || '',
      // reminder_email: parseInt(this.licenseform.value.remainder_days),
      // license_num: this.licenseform.value.licenseNumber,
      // license_coverage: this.licenseform.value.licenseCoverage1,
      // provinceshortName: this.licenseform.value.state

      provinceId: this.insurancestate_id,
      provinceName: this.insurancestatename,
      provinceStaxbillId: this.fusebillId,
      expiryDate:
        this.datePipe.transform(
          this.licenseform.value.expiryDate,
          'MM-dd-yyyy'
        ) || '',
      remainder_days: parseInt(this.licenseform.value.remainder_days),
      licenseNumber: this.licenseform.value.licenseNumber,
      licenseCoverage: this.licenseform.value.licenseCoverage,
      provinceshortName: this.licenseform.value.state  //
    };

    console.log(obj)
    let licenceExist = false;

    for (let broker of this.addlicenseformDataShared) {
      if (broker.licenseNumber == obj.licenseNumber) {
        licenceExist = true;
        break;
      } else {
        licenceExist = false;
      }
    }
    if (licenceExist) {
      Swal.fire({ title: 'Info', text: 'License Number already exist' });
    } else {
      this.addlicenseformDataShared.push(obj);
      console.log(this.addlicenseformDataShared);
      this.insurancestate_id = '';
      this.insurancestatename = '';
      this.fusebillId = '';
      // // this.adminData = JSON.parse(sessionStorage.getItem('adminData') || '[]');
      this.licenseform.reset();
      this.addlicenseformtable = true;
      this.addlicenseform = false;
      sessionStorage.setItem(
        'addlicenseformData',
        JSON.stringify(this.addlicenseformData)
      );
      $('#basicModal1Shared').modal('hide');
      $('#BrokerSharedNewDetails').modal('show');

    }
  }
  addeo() {
    if (this.eoform.invalid) {
      console.log(this.eoform);
      return;
    }
    console.log(this.eoform)


    var accessToken = sessionStorage.getItem('accessToken');
    var updateLicenseEO = '/api/ap/broker/' + this.brokerid + '/updateLicenceEO';



    let data = {
      "certificateNumber": this.eoform.value.certificateNumber,
      "expiryDate": moment(this.eoform.value.expiryDate, "MM-DD-YYYY").format("MM-DD-YYYY"),
      "insurerName": this.capitalize(this.eoform.value.insurerName),
      "policyNumber": this.eoform.value.policyNumber
    }
    this.http
      .put(environment.apiUrl + updateLicenseEO, data, {
        headers: {
          Authorization: 'Bearer ' + accessToken,
          'Content-Type': 'application/json',
        },
      })
      .subscribe(
        (response: any) => {
          if (response['status'] == 200 || response['statusCode'] == 200) {
            this.getBrokerDetails()
            // this.getServiceWorkerDetails()
            this.http.get(environment.apiUrl + '/api/ap/global/set-adminAdvisors').subscribe((newResponse) => {
              this.http.post(environment.reportApiUrl + '/websocket/advisor/notification-to-others', {
                "message": "Advisors information has been updated. Please refresh screen."
              }, {
                headers: {
                  Authorization: 'Bearer ' + accessToken,
                  'Content-Type': 'application/json',
                }
              }).subscribe((res) => {
                console.log({ res })
              })
            })
            this.eoform.reset()

          } else {
            Swal.fire({ title: 'Error', text: response.message })
          }
        },
        (error) => {
          if (
            error.status == 400 ||
            error.status == 401 ||
            error.status == 402 ||
            error.status == 403
          ) {
            Swal.fire({
              title: 'Error',
              text: error.error.error.message,
              showDenyButton: false,
              showCancelButton: false,
              confirmButtonText: 'Ok',
            }).then((result) => {
              /* Read more about isConfirmed, isDenied below */
              if (result.isConfirmed) {
                sessionStorage.clear();
                this.router.navigate(['/login']);
              }
              else {
                sessionStorage.clear();
                this.router.navigate(['/login']);
              }
            });
          } else {
            // Swal.fire(error.error.error.message)
            Swal.fire({ title: 'Error', text: error.error.error.message });
          }
          // this.toastrService.error("Invalid Credentials", 'Error!');
        }
      );
  }
  addform() {


    // this.getPlansId()

    this.plansIds =  JSON.parse(sessionStorage.getItem('plansIds') ?? '[]')
    console.log('this.plansIds',this.plansIds);

    this.plansIds.length <= 0 ? this.plansError = true : this.plansError = false
    if (this.formCreation.invalid || this.plansIds.length <= 0) {
      this.formCreation.markAllAsTouched()
      console.log(this.formCreation.value, this.formCreation.controls, this.plansIds);
      return;
    }
    console.log(JSON.stringify(this.formCreation.value, null, 2));

    let formDetails = []

    // if (this.formCreation.value.formplanLevels && this.formCreation.value.formplanLevels.length > 0) {
    //   let formplansData = this.formCreation.value.formplanLevels

    //   for (let i = 0; i < formplansData.length; i++) {
    //     this.fromplansarry.push(formplansData[i].id)
    //   }
    // }
    let logoDetails = '';
    if (this.uploadFormlogo) {

      (logoDetails = this.uploadFormlogo),
        'form_logo' +
        Date.now() +
        '.' +
        this.uploadFormlogo.name.split('.').pop().toLowerCase();

    } else {

      logoDetails = '';
    }

    let image;

    if (this.uploadFormlogo) {
      var reader = new FileReader();
      reader.readAsDataURL(this.uploadFormlogo);

      reader.onload = (_event) => {

        image = reader.result
        this.editFormlogo = image
      };
    }

    var form = new FormData();
    var form1 = new FormData();
    let obj = {
      formType: 'CUSTOM',

      name: this.capitalize(this.formCreation.value.formName),
      description: this.capitalize(this.formCreation.value.formDescription),
      link: "",
      planLevelsisName: false,
      planLevels: this.plansIds || [],
      productType: this.formCreation.value.pricingOptions || "GIG",
      logo: logoDetails || "",
    };

    form1.append("formType", 'CUSTOM'),
      form1.append("name", this.capitalize(this.formCreation.value.formName)),
      form1.append("description", this.capitalize(this.formCreation.value.formDescription)),
      form1.append("link", ''),
      form1.append('formDetails', JSON.stringify(this.fromplansarry) || "");

    formDetails.push(obj)
    // let finalobj={
    //   broker_name: this.brokerinfoName,
    //   sales_tracking_code: "",
    //   formDetails:formDetails
    // }


    console.log(formDetails)
    form.append("formDetails", JSON.stringify(formDetails));
    form.append("broker_name", this.brokerinfoName);
    form.append("sales_tracking_code", '');
    form.append("logo", logoDetails || "");
    form.append("profileBrokerId", this.formCreation.value.profileName || this.profileBasedOriginalId);


    var accessToken = sessionStorage.getItem('accessToken');
    var addlcienseinfo = '/api/ap/v2/broker/' + (this.profileBasedOriginalId || this.brokerid) + '/createFormWithLogo';

    var requestOptions: any = {
      method: 'POST',

      body: form,

      redirect: 'follow',
      headers: { Authorization: 'Bearer ' + accessToken },
    };

    // console.log(requestOptions)

    fetch(environment.apiUrl + addlcienseinfo, requestOptions)
      .then((response) => response.text())

      .then((response: any) => {
        response = JSON.parse(response);
        if (response['status'] == 200 || response['statusCode'] == 200) {
          this.http.get(environment.apiUrl + '/api/ap/global/set-adminAdvisors').subscribe((newResponse) => {
            this.http.post(environment.reportApiUrl + '/websocket/advisor/notification-to-others', {
              "message": "Advisors information has been updated. Please refresh screen."
            }, {
              headers: {
                Authorization: 'Bearer ' + accessToken,
                'Content-Type': 'application/json',
              }
            }).subscribe((res) => {
              console.log({ res })
            })
          })
          this.getBrokerDetails()
          // this.getServiceWorkerDetails()
          this.addformDetails.push(obj);
          // // this.adminData = JSON.parse(sessionStorage.getItem('adminData') || '[]');

          this.formCreation.reset();
          this.showFormsDetails = true;
          this.showaddform = false;
          this.showPlans = false;
          this.showPricing = false



          this.fromplansarry = []
          this.customForm = false
          $('#addFormDetails').modal('hide');
          sessionStorage.setItem(
            'addformDetails',
            JSON.stringify(this.addformDetails)
          );


          this.uploadFormlogo = ""
          $('#basicModal1').modal('hide');
        } else {
          Swal.fire({ title: 'Error', text: response.message })
        }
      },
        (error) => {
          if (
            error.status == 400 ||
            error.status == 401 ||
            error.status == 402 ||
            error.status == 403
          ) {
            Swal.fire({
              title: 'Error',
              text: error.error.error.message,
              showDenyButton: false,
              showCancelButton: false,
              confirmButtonText: 'Ok',
            }).then((result) => {
              /* Read more about isConfirmed, isDenied below */
              if (result.isConfirmed) {
                sessionStorage.clear();
                this.router.navigate(['/login']);
              }
              else {
                sessionStorage.clear();
                this.router.navigate(['/login']);
              }
            });
          } else {
            // Swal.fire(error.error.error.message)
            Swal.fire({ title: 'Error', text: error.error.error.message });
          }
          // this.toastrService.error("Invalid Credentials", 'Error!');
        }
      );


    this.plansIds = []
    this.saveError = false


  }

  deletebrokerlicense(index: any) {
    const Data = this.addlicenseformData;
    const removed = Data.splice(index, 1); // Mutates fruits and returns array of removed items

    sessionStorage.setItem(
      'addlicenseformData',
      JSON.stringify(this.addlicenseformData)
    );
    this.addlicenseformData = JSON.parse(
      sessionStorage.getItem('addlicenseformData') || '[]'
    );

    if (this.addlicenseformData.length == 0) {
      this.addlicenseform = true;
      this.addlicenseformtable = false;
    }
  }
  deleteform(form: any, index: any) {



    Swal.fire({
      title: 'Alert',
      text: 'Are you sure you want to delete Form ' + form.name + '',
      showDenyButton: false,
      showCancelButton: true,
      confirmButtonText: 'Proceed',
    }).then((result) => {
      /* Read more about isConfirmed, isDenied below */
      if (result.isConfirmed) {
        const Data = this.addformDetails;
        const removed = Data.splice(index, 1); // Mutates fruits and returns array of removed items

        sessionStorage.setItem(
          'addformDetails',
          JSON.stringify(this.addformDetails)
        );
        this.addformDetails = JSON.parse(
          sessionStorage.getItem('addformDetails') || '[]'
        );

        if (this.addformDetails.length == 0) {
          this.showaddform = true;
          this.showPlans = true;
          this.initializePlansArray(this.productsArray, false, false, 'CUSTOM')
          this.showFormsDetails = false;
        }

      }
    })

  }

  editbrokerlicense(broker: any, index: any) {
    console.log(broker);
    this.editindex = index;
    this.editbrokerlicensenumber = broker.license_num;
    this.editbrokerlicensecoverage = broker.license_coverage;
    this.editbrokerlicensestate = broker.provinces_name;
    this.editbrokerlicenseexpirydate = broker.expiry_date;
    this.editbrokerlicenseexpiryremainder = broker.reminder_email;
  }

  editform(form: any, index: any) {

    this.editindex = index;
    this.editFormType = 'CUSTOM'
    this.editFormName = form.name;
    this.editFormDescription = form.description;
    this.editFormlink = "";
    this.editFormlogo = "";
    this.editFormDisclousreAggrement = "";
  }





  editbrokerlicenseSubmit() {
    if (this.licenseform.invalid) {
      console.log(this.licenseform);
      return;
    }
    console.log(JSON.stringify(this.licenseform.value, null, 2));

    let obj = {
      provinces_id: this.insurancestate_id,
      provinces_name: this.insurancestatename,
      expiry_date:
        this.datePipe.transform(
          this.licenseform.value.expiryDate,
          'MM-dd-yyyy'
        ) || '',
      reminder_email: parseInt(this.licenseform.value.remainder_days),
      license_num: this.licenseform.value.licenseNumber,
      license_coverage: this.licenseform.value.licenseCoverage,
    };
    this.addlicenseformData[this.editindex] = obj;

    sessionStorage.setItem(
      'addlicenseformData',
      JSON.stringify(this.addlicenseformData)
    );
    this.addlicenseformData = JSON.parse(
      sessionStorage.getItem('addlicenseformData') || '[]'
    );

    this.licenseform.reset();
    this.addlicenseform = false;
    this.addlicenseformtable = true;
    $('#basicModaledit').modal('hide');
    // $('#basicModal1').modal('hide');
  }

  uploadadminFormlogo(event1: any) {
    console.log('test');

    console.log(event1)
    var fileExtension = '.' + event1.target.files[0].name.split('.').pop();

    // alert(event.target.files[0].name.replace(event.target.files[0].name,"void.pdf"))
    this.uploadFormlogo = event1.target.files[0];

    var allowedMimes = [
      'image/jpeg',
      'image/pjpeg',
      'image/png',
      'application/pdf',
    ];

    let error = false;

    let message = '';

    if (allowedMimes.includes(this.uploadFormlogo.type)) {
      const maxFileSize = 1024 * 1024 * (environment.fileSize ? +environment.fileSize : 5);

      if (this.uploadFormlogo.size <= maxFileSize) {
        //300KB

        error = false;
        var reader = new FileReader();
        reader.readAsDataURL(event1.target.files[0]);

        reader.onload = (_event) => {
          // this.showimagelogo = false;
          this.editFormlogo = reader.result;
          // this.imagedisplay = reader.result;
        };
      } else {
        error = true;
        // message = 'File size is too large,maximum file size is 5 MB'

        message = `File size is too large,maximum file size is 5 MB`
        alert(message);
      }
    } else {
      error = true;

      message = 'Invalid file type. Only jpg, png image,pdf files are allowed.';
      alert(message);
    }
  }



  getPlansId() {
    this.plansIds = []
    Object.keys(this.allplansArray).forEach((product: any) => {
      return Object.keys(this.allplansArray[product]).forEach((plan: any) => {
        if (typeof this.allplansArray[product][plan] === 'object' && this.allplansArray[product][plan].planCheckbox === true && this.allplansArray[product][plan].planId) {
          console.log(this.allplansArray[product][plan].planId, plan)
          this.plansIds.push(this.allplansArray[product][plan].planId)
        }
      })
    })
    this.plansIds = this.plansIds.filter(item => item !== null);
    console.log("planIds", this.plansIds)
  }


  resetFormCreation() {
    this.plansError = false;
    this.formCreation.reset()
    this.allplansArray = []
    this.closePlans();
  }
  editFormSubmit() {
    // this.getPlansId()

    this.plansIds =  JSON.parse(sessionStorage.getItem('plansIds') ?? '[]')
    console.log('this.plansIds',this.plansIds);

    console.log(this.formCreation.controls);
    this.plansIds.length <= 0 ? this.plansError = true : this.plansError = false

    if (this.formCreation.invalid || this.plansIds.length <= 0) {
      console.log(this.formCreation.value, this.plansIds.length);
      return;
    }
    // console.log(JSON.stringify(this.formCreation.value, null, 2));

    var accessToken = sessionStorage.getItem('accessToken');


    // var saveAdvisorForm = '/api/ap/broker/' + this.editFormDetails.brokerId + '/form/' + this.editFormDetails.id + '/modify';
    let id = this.profileBasedOriginalId || this.brokerid
    var saveAdvisorForm = '/api/ap/broker/' + id + '/form/' + this.editFormDetails.id + '/modify';


    let logoDetails = '';
    if (this.uploadFormlogo) {
      (logoDetails = this.uploadFormlogo),
        'form_logo' +
        Date.now() +
        '.' +
        this.uploadFormlogo.name.split('.').pop().toLowerCase();
    } else {
      logoDetails = '';
    }


    let image;

    if (this.uploadFormlogo) {
      var reader = new FileReader();
      reader.readAsDataURL(this.uploadFormlogo);

      reader.onload = (_event) => {

        image = reader.result
        this.editFormlogo = image
      };
      this.showPlans = false
    }
    // if (this.formCreation.value.formplanLevels && this.formCreation.value.formplanLevels.length > 0) {
    //   let formplansData = this.formCreation.value.formplanLevels

    //   for (let i = 0; i < formplansData.length; i++) {
    //     this.fromplansarry.push(formplansData[i].id)
    //   }
    // }

    let obj = {
      formType: 'CUSTOM',
      name: this.capitalize(this.formCreation.value.formName),
      description: this.capitalize(this.formCreation.value.formDescription),
      link: "",
      planLevels: this.plansIds || [],
      logo: logoDetails || "",
      formDisclosureAgreement: "",
      productType: this.formCreation.value.pricingOptions || "GIG",

    };


    console.log(obj)

    var form = new FormData();
    form.append("newType", 'CUSTOM');
    form.append("name", this.capitalize(this.formCreation.value.formName));
    form.append("description", this.capitalize(this.formCreation.value.formDescription));
    form.append("nameOrId", "false");
    form.append("planlevel", JSON.stringify(obj.planLevels) || "[]");
    form.append("logo", logoDetails || "");
    form.append("productType", this.formCreation.value.pricingOptions || "GIG");
    form.append("profileBrokerId", this.formCreation.value.profileName || this.profileBasedOriginalId);





    var requestOptions: any = {
      method: 'POST',

      body: form,

      redirect: 'follow',
      headers: { Authorization: 'Bearer ' + accessToken },
    };

    console.log(requestOptions)

    fetch(environment.apiUrl + saveAdvisorForm, requestOptions)
      .then((response) => response.text())

      .then((response: any) => {
        this.uploadFormlogo = ''
        this.closePlans();

        this.http.get(environment.apiUrl + '/api/ap/global/set-adminAdvisors').subscribe((newResponse) => {
          this.http.post(environment.reportApiUrl + '/websocket/advisor/notification-to-others', {
            "message": "Advisors information has been updated. Please refresh screen."
          }, {
            headers: {
              Authorization: 'Bearer ' + accessToken,
              'Content-Type': 'application/json',
            }
          }).subscribe((res) => {
            console.log({ res })
          })
        })

        this.getBrokerDetails()
        // this.getServiceWorkerDetails()
        this.addformDetails[this.editindex] = obj;

        this.formCreation.reset();
        this.showFormsDetails = true;
        this.showaddform = false;
        sessionStorage.setItem(
          'addformDetails',
          JSON.stringify(this.addformDetails)
        );
        $('#basicModalFormedit').modal('hide');


      })

    this.plansIds = []
  }



  hideaddlicenseform() {
    this.licenseform.reset();
  }
  addextraform() {
    this.customForm = false
    // this.form['formplanLevels'].clearValidators();

    // this.form['formplanLevels'].updateValueAndValidity();
    this.allplansArray = []
    this.initializePlansArray(this.productsArray, false, false, 'CUSTOM');
    this.showPlans = true;
    this.formCreation.reset();
    // $('#addFormDetails').modal('show');
    // this.formCreation.reset();
    // this.showaddform = true;

    this.showaddplans = true;
    this.showeditplans = false;
    $('#addFormDetails').modal('show');
  }
  uploadadminlogo(event1: any) {
    console.log('test');
    var fileExtension = '.' + event1.target.files[0].name.split('.').pop();

    // alert(event.target.files[0].name.replace(event.target.files[0].name,"void.pdf"))
    this.uploadlogo = event1.target.files[0];

    var allowedMimes = [
      'image/jpeg',
      'image/pjpeg',
      'image/png',
      'application/pdf',
    ];

    let error = false;

    let message = '';

    if (allowedMimes.includes(this.uploadlogo.type)) {
      const maxFileSize = 1024 * 1024 * (environment.fileSize ? +environment.fileSize : 5);

      if (this.uploadlogo.size <= maxFileSize) {
        //300KB

        error = false;
        var reader = new FileReader();
        reader.readAsDataURL(event1.target.files[0]);

        reader.onload = (_event) => {
          this.showimagelogo = false;

          this.imagedisplay = reader.result;
        };
      } else {
        error = true;
        // message = 'File size is too large,maximum file size is 5 MB'
        message = `File size is too large,maximum file size is 5 MB`
        alert(message);
      }
    } else {
      error = true;

      message = 'Invalid file type. Only jpg, png image,pdf files are allowed.';
      alert(message);
    }
  }
  uploadadmindisclosure(event1: any) {
    console.log('test');
    var fileExtension = '.' + event1.target.files[0].name.split('.').pop();

    // alert(event.target.files[0].name.replace(event.target.files[0].name,"void.pdf"))
    this.uploaddisclousreAggrement = event1.target.files[0];

    var allowedMimes = [
      'image/jpeg',
      'image/pjpeg',
      'image/png',
      'application/pdf',
    ];

    let error = false;

    let message = '';

    if (allowedMimes.includes(this.uploaddisclousreAggrement.type)) {
      const maxFileSize = 1024 * 1024 * (environment.fileSize ? +environment.fileSize : 5);

      if (this.uploaddisclousreAggrement.size <= maxFileSize) {
        //300KB

        error = false;
        var reader = new FileReader();
        reader.readAsDataURL(event1.target.files[0]);

        reader.onload = (_event) => {
          this.showdisclosureaggrement = false;

          this.imagedisplaypdf = reader.result;
        };
      } else {
        error = true;
        // message = 'File size is too large,maximum file size is 1 MB';

        message = `File size is too large,maximum file size is 5 MB`
        alert(message);
      }
    } else {
      error = true;

      message = 'Invalid file type. Only jpg, png image,pdf files are allowed.';
      alert(message);
    }
  }

  formConfig() {

    // var endPoint = `/api/ap/broker/formConfig?currentBrokerId=${this.route.snapshot.params['id']}`;
    // var accessToken = sessionStorage.getItem('accessToken');

    // this.http
    //   .get(environment.apiUrl + endPoint, {
    //     headers: {
    //       Authorization: 'Bearer ' + accessToken,
    //       'Content-Type': 'application/json',
    //     },
    //   })
    //   .subscribe(
    //     (response: any) => {
    //       if (response['status'] == 200) {
    //         this.getBrokerDetails()
    //         // this.getServiceWorkerDetails()
    //         this.allBrokers = response.data.allBrokers;
    //         this.allBrokersUnique = response.data.allBrokers.sort(
    //           (a: any, b: any) => (a.name > b.name ? 1 : -1)
    //         );
    //         this.configprovinceres = response.data.allCountrys[0].countryStates.sort(
    //           (a: any, b: any) => (a.shortName > b.shortName ? 1 : -1)
    //         );
    //         this.productsArray = response.data.packages
    //         this.prevSTC = response.data.prevSTC;
    //         this.licenseCoverage = response.data.licenseCoverage;
    //         this.licenseCoverageList = response.data.licenseCoverage;

    //         this.brokerType = response.data.brokerType;
    //         this.formType = response.data.formType;
    //         this.pricingOptions = response.data.forms

    //         this.advisorGroupContact = response.data.advisorGroupContact

    //         // for (let i = 0; i < this.productsArray.length; i++) {
    //         //   for (let j = 0; j < this.productsArray[i].planGroups.length; j++) {
    //         //     this.productsArrayList.push(this.productsArray[i].planGroups[j])
    //         //   }
    //         // }
    //       } else {
    //         Swal.fire({ title: 'Error', text: response.message });
    //       }
    //     },
    //     (error) => {
    //       if (
    //         error.status == 400 ||
    //         error.status == 401 ||
    //         error.status == 402 ||
    //         error.status == 403
    //       ) {
    //         Swal.fire({
    //           title: 'Error',
    //           text: error.error.error.message,
    //           showDenyButton: false,
    //           showCancelButton: false,
    //           confirmButtonText: 'Ok',
    //         }).then((result) => {
    //           if (result.isConfirmed) {
    //             sessionStorage.clear();
    //             this.router.navigate(['/login']);
    //           }
    //         });
    //       } else {
    //         Swal.fire({ title: 'Error', text: error.error.error.message });
    //       }
    //     }
    //   );

    // uncomment the commented and comment the uncomnmented - below - for changing the form config

    // this.store.dispatch(loadBrokerConfigData({id: this.route.snapshot.params['id']}));
    // this.brokerConfigData$ = this.store.select(state => state.brokerConfigData).pipe(
    //   startWith([]),
    //   takeUntil(this.destroy$)
    // );
    // this.brokerConfigData$.subscribe(data => {

    this.store.dispatch(loadBrokerFormConfigData());
    this.brokerFormConfigData$ = this.store.select(state => state.brokerFormConfigData).pipe(
      startWith([]),
      takeUntil(this.destroy$)
    );
    this.brokerFormConfigData$.subscribe(data => {

      if(data){
        console.log(data)
        // if (data?.brokerConfigData == undefined || Object.keys(data.brokerConfigData).length <= 0) {
        if (data?.brokerFormConfigData == undefined || Object.keys(data.brokerFormConfigData).length <= 0) {
          console.log('No data to process', new Date().toISOString());
          return;
        }
        if(Object.keys(this.brokerConfigData).length>0){
          return;
        }
        // this.brokerConfigData = data.brokerConfigData;
        this.brokerConfigData = {...data.brokerFormConfigData};
        this.getBrokerDetails()

        this.allBrokers = this.brokerConfigData.allBrokers;
        this.allBrokersUnique = [...this.brokerConfigData.allBrokers].sort(
          (a: any, b: any) => (a.name > b.name ? 1 : -1)
        );
        this.configprovinceres = [...this.brokerConfigData.allCountrys[0].countryStates].sort(
          (a: any, b: any) => (a.shortName > b.shortName ? 1 : -1)
        );
        // this.productsArray = this.brokerConfigData.packages
        this.prevSTC = this.brokerConfigData.prevSTC;
        this.licenseCoverage = this.brokerConfigData.licenseCoverage;
        this.licenseCoverageList = this.brokerConfigData.licenseCoverage;

        this.brokerType = this.brokerConfigData.brokerType;
        this.formType = this.brokerConfigData.formType;
        this.pricingOptions = this.brokerConfigData.forms

        this.advisorGroupContact = this.brokerConfigData.advisorGroupContact

        const accessToken = sessionStorage.getItem('accessToken')
        this.http.get(environment.apiUrl+`/api/ap/v2/rest/broker/formConfig?currentBrokerId=${this.route.snapshot.params['id']}`,{
          headers: {
            Authorization: 'Bearer ' + accessToken,
            'Content-Type': 'application/json',
          },
        }).subscribe((res:any)=>{
          console.log(res)
          this.productsArray = res?.data?.packages
        })

      }
    })
  }

  public provincelist(event: any) {
    // alert(event.target.value)

    this.configprovinceres.forEach((element: any) => {
      if (element.shortName == event.target.value) {
        this.provincialHealthcareUrl = element.provincialHealthcareUrl;
        this.provincialZipcodes = element.zipcodes.split(',');
        this.provincelistid = element.id;
        this.state_id = parseInt(element.id);
        this.statename = element.name;
      }
    });

    if (this.brokerregform.value.postalCode) {
      if (
        this.provincialZipcodes.indexOf(
          this.brokerregform.value.postalCode[0]
        ) == -1
      ) {
        this.invalidpostalcodeprivince = true;

        this.broker['postalCode'].markAsTouched();
        this.broker['postalCode'].updateValueAndValidity();
      } else {
        this.invalidpostalcodeprivince = false;
        // console.log("test1")
      }

      if (this.brokerregform.value.postalCode.length == 0) {
        this.invalidpostalcodeprivince = false;
        // console.log("test11")
      }
    }
  }
  // public insuranceprovincelist(event: any) {
  //   // alert(event.target.value)

  //   this.configprovinceres.forEach((element: any) => {
  //     if (element.shortName == event.target.value) {
  //       this.provincialHealthcareUrl = element.provincialHealthcareUrl;
  //       this.provincialZipcodes = element.zipcodes.split(',');
  //       this.provincelistid = element.id;
  //       this.insurancestate_id = parseInt(element.id);
  //       this.insurancestatename = element.name;
  //     }
  //   });
  // }
  public insuranceprovincelist(event: any) {
    this.configprovinceres.forEach((element: any) => {
      if (element.shortName == event.target.value) {
        this.provincialHealthcareUrl = element.provincialHealthcareUrl;
        this.provincialZipcodes = element.zipcodes.split(',');
        this.provincelistid = element.id;
        this.insurancestate_id = parseInt(element.id);
        this.insurancestatename = element.name;
        this.fusebillId = parseInt(element.fusebillId);
        this.provinceshortName = element.shortName
      }
    });
  }
  public insuranceprovincelist1(event: any) {
    this.configprovinceres.forEach((element: any) => {
      if (element.shortName == event) {
        this.provincialHealthcareUrl = element.provincialHealthcareUrl;
        this.provincialZipcodes = element.zipcodes.split(',');
        this.provincelistid = element.id;
        this.insurancestate_id = parseInt(element.id);
        this.insurancestatename = element.name;
        this.fusebillId = parseInt(element.fusebillId);
        this.provinceshortName = element.shortName
      }
    });
  }
  changeTextToUppercase(field: any, event: any) {
    console.log(field);
    const obj = {};

    this.postalvalue = event.target.value;

    if (this.provincialZipcodes.indexOf(this.postalvalue[0]) == -1) {
      // console.log("r")
      this.invalidpostalcodeprivince = true;
      this.broker['postalCode'].markAsTouched();
    } else {
      this.invalidpostalcodeprivince = false;
    }

    if (this.postalvalue.length == 0) {
      this.invalidpostalcodeprivince = false;
    }

    console.log(this.invalidpostalcodeprivince);

    //  postalcodeValidator1(this.invalidpostalcodeprivince )
  }

  public signupFormCheck(event) {
    console.log(event);

    if (event.target.value == 'true') {
      this.initializePlansArray(this.productsArray, false, false, 'CUSTOM')
      this.showaddform = true;
      this.showPlans = true;
      this.allplansArray = []
      this.formCreation.reset()
    } else {
      // this.showformtype = false;
      this.showaddform = false;
      this.allplansArray = []
      this.showPlans = false;
      this.saveError = false;

      this.formCreation.reset()

    }
  }
  public checkParentlogo(event) {
    if (event.target.value == 'true') {
      this.showparentlogocondition = false;
    } else {
      this.showparentlogocondition = true;
    }
  }
  public checkParentdisclosure(event) {
    if (event.target.value == 'true') {
      this.showparentdisclosurecondition = false;
      this.broker['disclosureAgreement'].clearValidators();

      this.broker['disclosureAgreement'].updateValueAndValidity();
      this.uploaddisclousreAggrement = ""
    } else {
      this.showparentdisclosurecondition = true;
      this.broker['disclosureAgreement'].setValidators([Validators.required]);

      this.broker['disclosureAgreement'].updateValueAndValidity();
    }
  }


  showPlansForSelection(type: string) {
    if (type === 'REGULAR') {
      this.initializePlansArray(this.productsArray, true, true, 'REGULAR')
    }
    if (type === 'EXECUTIVE') {
      this.initializePlansArray(this.productsArray, false, true, 'EXECUTIVE')
    }
    if (type === 'CUSTOM') {
      this.initializePlansArray(this.productsArray, false, false, 'CUSTOM')
    }
  }

  public selectFormname(event: any) {
    console.log(event.target.value);
    this.showPlans = true;
    this.showPlansForSelection(event.target.value)

    if (event.target.value == 'REGULAR' || event.target.value == 'EXECUTIVE') {
      // this.showaddform = true;
      this.customForm = false
      // this.form['formplanLevels'].clearValidators();

      // this.form['formplanLevels'].updateValueAndValidity();
    } else {
      this.customForm = true
      // this.form['formplanLevels'].setValidators([Validators.required]);;

      // this.form['formplanLevels'].updateValueAndValidity();
    }
    for (let i = 0; i < this.formType.length; i++) {

      if (this.formType[i].label == event.target.value) {

        // this.formTitle = this.formType[i].title
        // this.formDescription = this.formType[i].description
        this.formCreation.get('formName').setValue(this.formType[i].title);
        this.formCreation.get('formDescription').setValue(this.formType[i].description);
        this.cdr.detectChanges();
        setTimeout(() => {
          this.cdr.detectChanges(); // Ensure change detection runs after the current cycle
        });
      }

    }
  }

  public getBrokerlistData(event: any) {
    console.log(event.target.value);

    // alert(this.brokerregform.value.ParentbrokerName);
  }




  gotoadvsiorpage() {
    this.router.navigate(['/manageAdvisors/' + this.brokerid + '/viewAdvisor']);


  }
  public submitbasicInfo() {

    this.plansIds.length <= 0 && this.showaddform ? this.saveError = true : this.saveError = false
    console.log(this.plansIds.length <= 0, this.formCreation.invalid)

    if (this.brokerregform.invalid || this.saveError) {
      console.log(this.brokerregform.value);

      const invalid = [];
      const controls = this.brokerregform.controls;
      for (const name in controls) {
        if (controls[name].invalid) {
          invalid.push(name);
        }
      }
      console.log(invalid)

      this.brokerregform.markAllAsTouched();
      this.licenseform.markAllAsTouched();
      this.formCreation.markAllAsTouched();
      if (this.saveError) {
        const buttonToScrollTo = this.elementRef.nativeElement.querySelector('#scrollTarget');
        console.log({ buttonToScrollTo })

        buttonToScrollTo.scrollIntoView({ behavior: 'smooth' });
      }
    }

    else {
      this._LoaderService.ShowLoader()
      let secondaryEmail = this.brokerregform.value.secondaryEmail || "";
      let thirdEmail = this.brokerregform.value.thirdEmail;

      if (thirdEmail) {
        secondaryEmail = `${secondaryEmail ? `${secondaryEmail},` : ''}${thirdEmail}`;
      }



      let obj = {
        apt: "",
        city: this.capitalize(this.brokerregform.value.city),
        country: this.capitalize(this.brokerregform.value.country),
        line1: this.capitalize(this.brokerregform.value.streetAddress),
        line2: this.capitalize(this.brokerregform.value.streetAddress2),
        postalCode: this.brokerregform.value.postalCode,
        primaryEmail: this.brokerregform.value.primaryEmail,
        primaryPhone: this.brokerregform.value.primaryPhone,
        secondaryEmail: secondaryEmail || "",
        secondaryPhone: this.brokerregform.value.secondaryPhone || "",
        state: this.brokerregform.value.Province
      }

      var updatebasicConatctInfo = '/api/ap/broker/' + this.brokerid + '/updateContactInfo';
      var accessToken = sessionStorage.getItem('accessToken');
      this.http
        .put(environment.apiUrl + updatebasicConatctInfo, obj, {
          headers: {
            Authorization: 'Bearer ' + accessToken,
            'Content-Type': 'application/json',
          },
        })
        .subscribe(
          async (response: any) => {
            if (response['status'] == 200 || response['statusCode'] == 200) {
              var getAdvisors = '/api/ap/brokers/details';
              var GetBrokersDetails = '/api/ap/broker/' + this.route.snapshot.params['id'] + '/details';

              // await postServiceWorkerMessage(WorkerMessageType.Delete, [
              //   environment.apiUrl + GetBrokersDetails
              // ]);
              this._LoaderService.HideLoader()
              this.http.get(environment.apiUrl + '/api/ap/global/set-adminAdvisors').subscribe((newResponse) => {
                this.http.post(environment.reportApiUrl + '/websocket/advisor/notification-to-others', {
                  "message": "Advisors information has been updated. Please refresh screen."
                }, {
                  headers: {
                    Authorization: 'Bearer ' + accessToken,
                    'Content-Type': 'application/json',
                  }
                }).subscribe((res) => {
                  console.log({ res })
                })
              })
              this.brokerList = this.brokerList.map(advisor =>
                advisor.id == this.brokerid ? {
                  ...advisor,
                  email:obj.primaryEmail
               } : advisor
              );
              this.store.dispatch(loadAdvisorDataSuccess({advisorData:this.brokerList}))
              this.router.navigate(['/manageAdvisors']);
            } else {
              this._LoaderService.HideLoader()

              Swal.fire({ title: 'Error', text: response.message })
            }
          },
          (error) => {
            this._LoaderService.HideLoader()

            if (
              error.status == 400 ||
              error.status == 401 ||
              error.status == 402 ||
              error.status == 403
            ) {
              Swal.fire({
                title: 'Error',
                text: error.error.error.message,
                showDenyButton: false,
                showCancelButton: false,
                confirmButtonText: 'Ok',
              }).then((result) => {
                /* Read more about isConfirmed, isDenied below */
                if (result.isConfirmed) {
                  sessionStorage.clear();
                  this.router.navigate(['/login']);
                }
                else {
                  sessionStorage.clear();
                  this.router.navigate(['/login']);
                }
              });
            } else {
              // Swal.fire(error.error.error.message)
              Swal.fire({ title: 'Error', text: error.error.error.message });
            }
            // this.toastrService.error("Invalid Credentials", 'Error!');
          }
        );

    }
  }
  public submitSharedNewandexisting() {


    if (this.brokerSharedregform.invalid) {
      console.log(this.brokerSharedregform.value);

      const invalid = [];
      const controls = this.brokerSharedregform.controls;
      for (const name in controls) {
        if (controls[name].invalid) {
          invalid.push(name);
        }
      }
      console.log(invalid);

      this.brokerSharedregform.markAllAsTouched();


      // this.scrollToFirstInvalidControl1();
      if (this.saveError) {
        const buttonToScrollTo =
          this.elementRef.nativeElement.querySelector('#scrollTarget');
        console.log({ buttonToScrollTo });

        buttonToScrollTo.scrollIntoView({ behavior: 'smooth' });
      }
    } else {
      this._LoaderService.ShowLoader();








      // if(this.brokerregform.value.stc_generation =="true"){
      // console.log("1")

      // }
      // else{
      //   console.log("2")
      //   this.brokerregform.value.user_generated_stc = "false"
      // }

      const convertedItems = this.brokersalesCodes.map(item => ({
        ...item,
        commission: Number(item.commission)
      }));
      let secondaryEmail = this.brokerSharedregform.value.secondaryEmail || '';
      let thirdEmail = this.brokerSharedregform.value.thirdEmail || '';

      if (thirdEmail) {
        secondaryEmail = `${secondaryEmail ? `${secondaryEmail},` : ''
          }${thirdEmail}`;
      }
      // let inputData = {
      //   brokerCommissionType: 'shared',
      //   name: this.capitalize(this.brokerSharedregform.value.brokersName),
      //   parentId: +this.brokerSharedregform.value.ParentbrokerName,
      //   brokerType: this.brokerTypeName,
      //   // brokerType: "Advisor",
      //   businessNumber: this.brokerSharedregform.value.businessnumber || '',
      //   email: this.brokerSharedregform.value.primaryEmail || '',
      //   secondaryEmail: secondaryEmail,
      //   address: {
      //     apt: '',
      //     line1: this.capitalize(this.brokerSharedregform.value.streetAddress),
      //     line2: this.capitalize(this.brokerSharedregform.value.streetAddress2) || '',
      //     city: this.capitalize(this.brokerSharedregform.value.city) || '',
      //     province: this.brokerSharedregform.value.Province || '',
      //     country: this.capitalize(this.brokerSharedregform.value.country),
      //     postalCode: this.brokerSharedregform.value.postalCode || '',
      //     provinceId: this.state_id,
      //     countryId: 1,
      //     primaryEmail: this.brokerSharedregform.value.primaryEmail || '',
      //     secondaryEmail: secondaryEmail,
      //     primaryPhone: this.brokerSharedregform.value.primaryPhone || '',
      //     secondaryPhone: this.brokerSharedregform.value.secondaryPhone || '',
      //   },
      //   groupContacts: [],
      //   licenses: [],
      //   brokerEO: {},
      //   brokerDetails: convertedItems,
      //   primaryBrokerId: this.brokersalesCodes[0].brokerId



      // };
      let inputData = {
        brokerCommissionType: 'shared',
        name: this.capitalize(this.brokerSharedregform.value.brokersName),
        parentId: +this.brokerSharedregform.value.ParentbrokerName,
        // brokerType: '',
        brokerType: "Advisor",
        businessNumber: undefined,
        email: undefined,
        secondaryEmail: undefined,
        address: {
          apt: undefined,
          line1: undefined,
          line2: undefined,
          city: undefined,
          province: undefined,
          country: undefined,
          postalCode: undefined,
          provinceId: undefined,
          countryId: 1,
          primaryEmail: undefined,
          secondaryEmail: undefined,
          primaryPhone: undefined,
          secondaryPhone: undefined,
        },
        groupContacts: [],
        licenses: [],
        brokerEO: {},
        brokerDetails: convertedItems,
        primaryBrokerId: this.brokersalesCodes[0].brokerId



      };

      // formdata.append("formDisclosureAgreement1", "");

      var accessToken = sessionStorage.getItem('accessToken');
      // var brokerRegistartion = '/api/ap/broker/registrationNew1';
      // var brokerRegistartion = '/api/ap/v2/broker/registration/withGroupContact';

      var brokerRegistartion = '/api/ap/v3/broker/registration';

      var requestOptions: any = {
        method: 'POST',

        body: JSON.stringify(inputData),

        redirect: 'follow',
        headers: {
          Authorization: 'Bearer ' + accessToken,
          'Content-Type': 'application/json',
        },
      };

      // console.log(requestOptions)

      fetch(environment.apiUrl + brokerRegistartion, requestOptions)
        .then((response) => response.text())

        .then(async (response: any) => {
          // console.log(response);
          response = JSON.parse(response);

          if (response['status'] == 200) {
            // this.showsoleAdvisorData = false;
            this._LoaderService.HideLoader();
            Swal.fire({ title: 'Info', text: response.message });
            // this.router.navigate([
            //   '/manageAdvisors'
            // ]);
            this.http.get(environment.apiUrl + '/api/ap/global/set-adminAdvisors').subscribe((newResponse) => {
              this.http.post(environment.reportApiUrl + '/websocket/advisor/notification-to-others', {
                "message": "Advisors information has been updated. Please refresh screen."
              }, {
                headers: {
                  Authorization: 'Bearer ' + accessToken,
                  'Content-Type': 'application/json',
                }
              }).subscribe((res) => {
                console.log({ res })
              })
              // window.location.reload()
            })


          } else {
            this._LoaderService.HideLoader();

            Swal.fire({ title: 'Error', text: response.message });
          }
        });
    }
  }
  public submitSharedNew() {
    // Object.keys(this.brokerregform.controls).forEach((val, key) => console.log(`${val}: ${this.brokerregform.controls[val].value}`))

    console.log(this.brokerregform.value);

    // return;
    // console.log(this.brokersalesCodes)

    this.plansIds.length <= 0 && this.showaddform
      ? (this.saveError = true)
      : (this.saveError = false);
    console.log(this.plansIds.length <= 0, this.formCreation.invalid);

    if (this.brokerregform.invalid) {
      console.log(this.brokerregform.value);

      const invalid = [];
      const controls = this.brokerregform.controls;
      for (const name in controls) {
        if (controls[name].invalid) {
          invalid.push(name);
        }
      }
      console.log(invalid);

      this.brokerregform.markAllAsTouched();
      this.adminform.markAllAsTouched();
      this.licenseform.markAllAsTouched();
      this.formCreation.markAllAsTouched();
      // this.scrollToFirstInvalidControl1();
      if (this.saveError) {
        const buttonToScrollTo =
          this.elementRef.nativeElement.querySelector('#scrollTarget');
        console.log({ buttonToScrollTo });

        buttonToScrollTo.scrollIntoView({ behavior: 'smooth' });
      }
    } else {
      this._LoaderService.ShowLoader();

      let license = {
        // provinces_id: this.insurancestate_id,
        // provinces_name: this.insurancestatename,
        // expiry_date:
        //   this.datePipe.transform(
        //     this.licenseform.value.expiryDate,
        //     'MMM-dd-yyyy'
        //   ) || '',
        // reminder_email: parseInt(this.licenseform.value.remainder),
        // license_num: this.licenseform.value.licenseNumber,
        // license_coverage: this.licenseform.value.licenseCoverage1,

        provinceId: this.insurancestate_id,
        provinceName: this.insurancestatename,
        expiryDate:
          this.datePipe.transform(
            this.licenseform.value.expiryDate,
            'MM-dd-yyyy'
          ) || '',
        reminderMailDays: parseInt(this.licenseform.value.remainder),
        licenseNo: this.licenseform.value.licenseNumber,
        licenseCoverage: this.licenseform.value.licenseCoverage,
      };
      this.licensesInfo.push(license);
      let data: any = {
        formType: this.brokerregform.value.Signupformtype,
        name: this.brokerregform.value.formName,
        description: this.brokerregform.value.formDescription,
        link: this.brokerregform.value.formLink,
        planLevels: '',
      };

      console.log(data);
      this.SignupFormData.push(data);

      let disclousreDetails = '';
      let parentlogo = '';
      if (this.uploaddisclousreAggrement) {
        (disclousreDetails = this.uploaddisclousreAggrement),
          'Admin_logo' +
          Date.now() +
          '.' +
          this.uploaddisclousreAggrement.name.split('.').pop().toLowerCase();
      } else {
        disclousreDetails = '';
      }

      if (this.uploadlogo) {
        (parentlogo = this.uploadlogo),
          'Admin_logo' +
          Date.now() +
          '.' +
          this.uploadlogo.name.split('.').pop().toLowerCase();
      } else {
        parentlogo = '';
      }



      let FormDetails: any = this.addformDetails;

      var formdata = new FormData();
      let licenses = JSON.parse(sessionStorage.getItem('addlicenseformData'));
      if (licenses == null) licenses = '';
      for (let i = 0; i < FormDetails.length; i++) {
        formdata.append('formLogo' + [i + 1] + '', FormDetails[i].logo);
      }
      let secondaryEmail = this.brokerregform.value.secondaryEmail || '';
      let thirdEmail = this.brokerregform.value.thirdEmail || '';

      if (thirdEmail) {
        secondaryEmail = `${secondaryEmail ? `${secondaryEmail},` : ''
          }${thirdEmail}`;
      }

      console.log(this.adminSahredData)
      console.log(licenses)
      console.log(this.EOinsurenceInfo)

      // for (let i = 0; i < this.adminSahredData.length; i++) {
      //   this.adminSahredData[i].phoneNum = this.adminSahredData[i]['phoneNumber'];
      //   delete this.adminSahredData[i].phoneNum;
      // }



      let groupContactArray = this.adminSahredData.map(item => {
        return {
          firstName: item.firstName,
          lastName: item.lastName,
          phoneNumber: item.phoneNum,
          role: item.role,
          email: item.email,
          roleName: item.roleName,
        };
      });


      console.log(this.addlicenseformDataShared)
      let licenseData = this.addlicenseformDataShared.map(item => {
        return {
          provinceId: item.provinceId,
          provinceName: item.provinceName,
          provinceStaxbillId: item.provinceStaxbillId,
          reminderMailDays: item.remainder_days,
          licenseNo: item.licenseNumber.toString(),
          licenseCoverage: item.licenseCoverage,
          provinceshortName: item.provinceshortName,
          expiryDate: item.expiryDate
        };
      });



      let eoDetails = {}
      if (this.EOinsurenceInfo) {
        eoDetails = {
          "insurerName": this.EOinsurenceInfo.insurerName,
          "policyNo": this.EOinsurenceInfo.policyNumber,
          "certificateNo": this.EOinsurenceInfo.certificateNumber,
          "expiryDate": this.EOinsurenceInfo.expiryDate,
        }
      }
      let inputData = {
        brokerCommissionType: 'sole',
        name: this.capitalize(this.brokerregform.value.brokersName),
        parentId: +this.brokerregform.value.ParentbrokerName,
        brokerType: this.brokerTypeName,
        businessNumber: this.brokerregform.value.businessnumber || '',
        email: this.brokerregform.value.primaryEmail || '',
        secondaryEmail: secondaryEmail,
        address: {
          apt: '',
          line1: this.capitalize(this.brokerregform.value.streetAddress),
          line2: this.capitalize(this.brokerregform.value.streetAddress2) || '',
          city: this.capitalize(this.brokerregform.value.city) || '',
          province: this.brokerregform.value.Province || '',
          country: this.capitalize(this.brokerregform.value.country),
          postalCode: this.brokerregform.value.postalCode || '',
          provinceId: this.state_id,
          countryId: 1,
          primaryEmail: this.brokerregform.value.primaryEmail || '',
          secondaryEmail: secondaryEmail,
          primaryPhone: this.brokerregform.value.primaryPhone || '',
          secondaryPhone: this.brokerregform.value.secondaryPhone || '',
        },
        groupContacts: groupContactArray || [],
        licenses: licenseData || [],
        brokerEO: eoDetails || {},



      };



      console.log(inputData)

      // formdata.append("formDisclosureAgreement1", "");

      var accessToken = sessionStorage.getItem('accessToken');
      // var brokerRegistartion = '/api/ap/broker/registrationNew1';
      // var brokerRegistartion = '/api/ap/v2/broker/registration/withGroupContact';

      var brokerRegistartion = '/api/ap/v3/broker/registration';

      var requestOptions: any = {
        method: 'POST',

        body: JSON.stringify(inputData),

        redirect: 'follow',
        headers: {
          Authorization: 'Bearer ' + accessToken,
          'Content-Type': 'application/json',
        },
      };

      // console.log(requestOptions)

      fetch(environment.apiUrl + brokerRegistartion, requestOptions)
        .then((response) => response.text())

        .then(async (response: any) => {
          // console.log(response);
          response = JSON.parse(response);

          if (response['status'] == 200) {
            // $("#BrokerSharedNewDetails").hide()


            this.brokersalesCodes.push({
              brokerId: response.data.broker.id,
              brokerName: response.data.broker.name,
              commission: '',
            });
            this.labeldata = []
            this.realdata = []
            for (let i = 0; i < this.brokersalesCodes.length; i++) {
              this.labeldata.push(this.brokersalesCodes[i].brokerName);
              this.realdata.push(this.brokersalesCodes[i].commission);
              // this.colordata.push(this.chartInfo[i].colorcode);
            }
            this.createChart(this.labeldata, this.realdata);
            if (this.brokersalesCodes.length == +this.broker['brokerCount'].value + 1) {
              this.showSharedBrokerList = false
              this.showaddprofileData = false
              this.showaddprofileData = false
            }
            else {
              this.showSharedBrokerList = true
            }
            const preservedValues = {
              brokerCount: this.brokerregform.get('brokerCount')?.value,

              brokerShare: this.brokerregform.get('brokerShare')?.value

            };
            this.brokerregform.reset(preservedValues);
            this.adminform.reset();
            this.licenseform.reset();
            this.formCreation.reset();
            this.adminData = [];
            this.addadminform = true
            this.showaddadmin = false
            this.addlicenseformData = []
            this.addlicenseformtable = false;
            this.addlicenseform = true;
            this.addEOform = true
            this.showaddEOdetails = false

            this.eoform.reset();
            console.log(this.brokersalesCodes)
            // this.sharedBrokerData.push(inputData)
            // this.showsoleAdvisorData = false;
            this._LoaderService.HideLoader();
            this.showsalestrackinCodeAuto = true;
            // this.showAdvisorAdvData = true;
            // this.salesTrackingInfo = response.data.broker;
            this.http.get(environment.apiUrl + '/api/ap/global/set-adminAdvisors').subscribe((newResponse) => {
              this.http.post(environment.reportApiUrl + '/websocket/advisor/notification-to-others', {
                "message": "Advisors information has been updated. Please refresh screen."
              }, {
                headers: {
                  Authorization: 'Bearer ' + accessToken,
                  'Content-Type': 'application/json',
                }
              }).subscribe((res) => {
                console.log({ res })
              })
            })






          }
          else {
            this._LoaderService.HideLoader();

            Swal.fire({ title: 'Error', text: response.message });
          }
        });
    }
  }
  public capitalize(str: any) {
    // if (str) {
    //   return str.charAt(0).toUpperCase() + str.slice(1);
    // }
    if (str) {
      const arr = str.split(" ");
      for (var i = 0; i < arr.length; i++) {
        arr[i] = arr[i].charAt(0).toUpperCase() + arr[i].slice(1);

      }
      const str2 = arr.join(" ");
      return str2
    }
  }
  checkEmailValidation(e: any) {
    // console.log('asasassasasa');
    let val = e.currentTarget.value;
    let notAlloewdSecvence = [
      '"',
      '#',
      '$',
      '%',
      '(',
      ')',
      '.',
      ',',
      ':',
      ';',
      '<',
      '>',
      '@',
      '[',
      ']',
    ];
    if (e.key == val.charAt(val.length - 1)) {
      if (notAlloewdSecvence.includes(val.charAt(val.length - 1))) {
        return false;
      }
    } else {
      if (val.length != 0) {
      } else {
      }
      return true;
    }
  }

  closePlans(){
    this.showaddplans = false;
    this.showeditplans = false;
  }

  addformDuplicate(){
    console.log('normal api call')
  }
}
export function postalcodeValidator(control: AbstractControl) {
  var postalRegexp = /^(?!.*[DFIOQU])[A-VXY][0-9][A-Z] ?[0-9][A-Z][0-9]$/gm;
  if (control.value && !postalRegexp.test(control.value)) {
    return { invalidPostalCode: true };
  }
  return null;
}
